import { HttpResponse } from '@angular/common/http';

import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';

import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  UntypedFormControl
} from '@angular/forms';

import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';

import {
  catchError,
  concatMap,
  finalize,
  map,
  switchMap,
  tap,
  take
} from 'rxjs/operators';
import { forkJoin, of as observableOf, Observable } from 'rxjs';

import { SpinnerService } from '@app/shared/spinner';
import {
  SuperHttpClientProvider,
  HttpCriteria,
  IFilter
} from '@app/core/http';

import { AdminConfigService } from '@app/core/admin-config.service';
import { Column } from '@models/column';
import { Table } from '@models/table';
import { SmartTableModule } from '@app/shared/smart-table/smart-table.module';
import { DatetimepickerComponent } from '@app/shared/datetimepicker/datetimepicker.component';
import { TranslateService } from '@ngx-translate/core';
import { SelectfincaComponent } from '@app/shared/selectfinca/selectfinca.component';
import { CellDateComponent } from '@app/shared/cell-date/cell-date.component';
import { BooleanFormatComponent } from '@app/shared/boolean-format/boolean-format';
import { SensorNameComponent } from '@app/shared/sensor-name/sensor-name';
import { ClientNameComponent } from '@app/shared/client-name/client-name';
import { SensorService } from '@app/core/sensor.service';
import { ClientService } from '@app/core/client.service';
import { ModuloService } from '@app/core/modulo.service';
import { SensorMoistureProfileService } from '@app/core/sensor-moisture-profile.service';
import { MoistureProfileAdminService } from '@app/core/moisture-profile-admin.service';
import { WeeklyReportSubscriptionService } from '@app/core/weekly-report-subscription.service';
import {
  buildWeeklyReportScopePayload,
  getAuthorizedWeeklyReportFincas,
  getWeeklyReportFincaLabel,
  hasWeeklyReportScopeSelection,
  normalizeWeeklyReportIds,
  normalizeWeeklyReportScopeType
} from '@app/core/weekly-report-scope.util';
import { ModuleNameComponent } from '@app/shared/module-name/module-name';
import { FincaService } from '@app/core/finca.service';
import { StationNameComponent } from '@app/shared/station-name/station-name';
import { ModulePowerSupplyComponent } from '@app/shared/module-power-supply/module-power-supply';
import { ClienteNameComponent } from '@app/shared/finca-name/finca-name';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';

const MMDD_DATE_FORMATS = {
  parse: {
    dateInput: 'MM-dd-yyyy'
  },
  display: {
    dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
};

@Component({
  standalone: false,
  selector: 'view-table-read',
  templateUrl: './read.component.html',
  styleUrls: ['./read.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: MAT_DATE_FORMATS, useValue: MMDD_DATE_FORMATS }
  ]
})
export class TableReadComponent implements OnInit {
  @ViewChild('usuarioForm', { static: false }) usuarioForm: TemplateRef<any>;
  @ViewChild('clienteForm', { static: false }) clienteForm: TemplateRef<any>;
  @ViewChild('fincaForm', { static: false }) fincaForm: TemplateRef<any>;
  @ViewChild('moduloForm', { static: false }) moduloForm: TemplateRef<any>;
  @ViewChild('eventForm', { static: false }) eventForm: TemplateRef<any>;
  @ViewChild('sensorForm', { static: false }) sensorForm: TemplateRef<any>;
  @ViewChild('confirmDialog', { static: false }) confirmDialog: TemplateRef<
    any
  >;
  @ViewChild('moistureProfileForm', { static: false })
  moistureProfileForm: TemplateRef<any>;
  @ViewChild('moistureSeasonForm', { static: false })
  moistureSeasonForm: TemplateRef<any>;
  @ViewChild('estacionForm', { static: false }) estacionForm: TemplateRef<any>;
  @ViewChild('sensorSettingsForm', { static: false })
  sensorSettingsForm: TemplateRef<any>;
  public dialogRef?: MatDialogRef<any>;
  private dialogStack: MatDialogRef<any>[] = [];

  public closeDialog(): void {
    const ref = this.dialogStack.pop() || this.dialogRef;
    ref?.close();
    this.dialogRef = this.dialogStack[this.dialogStack.length - 1];
  }

  public filterForm: UntypedFormGroup;
  public table: Table = null;
  public tableActions: { [actionName: string]: boolean } = null;
  public tableColsName: Column[] = [];
  public tableItemsPerPage = [10, 20, 30];
  public tableRows: any[] = null;
  public totalRows = 0;
  public contadorHoras = 0;
  public contadorMinutos = 0;
  public contadorSegundos = 0;
  public date: any = null;
  public time: any = null;

  public events: any[] = [];

  public criteria: HttpCriteria = new HttpCriteria({
    _filters: [
      {
        field: 'idCliente',
        operator: '=',
        value: ''
      }
    ],
    _perPage: -1
  });

  public settings: any;
  public data: any[] = [];
  public rowsPerpage: any[] = null;

  public eventModuleForm: UntypedFormGroup = new UntypedFormGroup({
    idModule: new UntypedFormControl(),
    date: new UntypedFormControl(),
    time: new UntypedFormControl(),
    comment: new UntypedFormControl('')
  });

  public fincas: any[] = [];
  public finca: any;
  public moduloFincas: any;
  public clientes: any;
  public cliente: any;
  public modulos: any[] = [];
  public sensorTypes: any;
  public sewerSystemTypes: any;
  public editData: any;
  public formTitle: 'Crear' | 'Editar';

  public fincaCliente: number;
  public fincaNombre: string;
  public fincaPoblacion: string;
  public fincaLat: number;
  public fincaLng: number;

  public moduloCliente: number;
  public moduloFinca: number;
  public moduloNombre: string;
  public moduloBateria: number;
  public moduloMac: string;
  public moduloLat: number;
  public moduloLng: number;
  public moduloPower: string;
  public moduloAemetCode: string;

  public sensorFiltroModulos: any[];
  public sensorFiltroModulo = -1;
  public moistureProfileFiltroCliente = -1;
  public fincaFiltroCliente = -1;
  public sensorModulo: number;
  public sensorAlarma: boolean;
  public sensorMin: number;
  public sensorMax: number;
  public sensorTipo: string;
  public moistureProfiles: any[] = [];
  public sensorMoistureProfileId: number | null = null;
  public moistureProfileControl = new UntypedFormControl(null);
  public sensorFincas: any;
  public sensorFinca = -1;
  public sensorCliente: number;

  public moistureProfileId: number | null = null;
  public moistureProfileCliente: number = -1;
  public moistureProfileName: string;
  public moistureProfileSeasons: any[] = [];
  public confirmTitleKey = 'COMMON.CONFIRM_TITLE';
  public confirmMessageKey = 'COMMON.CONFIRM_DELETE_SEASON';
  public confirmActionKey = 'COMMON.DELETE';
  public confirmCancelKey = 'COMMON.CANCEL';
  public pendingSeasonDeleteId: number | null = null;
  public seasonFormTitle: 'Crear' | 'Editar';
  public seasonId: number | null = null;
  public seasonName = '';
  public seasonStartMmdd = '';
  public seasonEndMmdd = '';
  public seasonStartDate: Date | null = null;
  public seasonEndDate: Date | null = null;
  public seasonThreshold1: number = 0;
  public seasonThreshold2: number = 0;
  public seasonPriority: number = 0;
  public seasonEnabled = true;
  public seasonError = '';
  // Configuraciones de sensor
  public sensorSettings: any[] = [];
  public sensorSettingsDates: Date[] = [];
  public sensorSettingsTimes: string[] = [];
  // Humedad
  public sensorCampo = 0;
  public sensorRecarga = 0;
  public sensorH1 = false;
  public sensorH2 = false;
  public sensorH3 = false;
  public sensorH4 = false;
  public sensorH5 = false;
  public sensorH6 = false;
  public sensorH7 = false;
  public sensorH8 = false;
  public sensorDrenaje = 'H10';
  public sensorEdInvert = false;
  // Calibración
  public sensorCalibracion: any = 0;
  // Conductividad
  public sensorPermitividad: any = 0;
  // Caudal
  public sensorGoterosLinea = 0;
  public sensorGoterosArbol = 0;
  // Instante (fecha y hora)
  public sensorFecha: Date = new Date();
  public hora = '00:00';

  public alarmFincaIds = new Set<number>();
  public alarmFincaLoading = new Set<number>();

  private readonly mmddRegex = /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
  public compareSelectValues(a: unknown, b: unknown): boolean {
    return String(a) === String(b);
  }

  public usuarioNombre: string;
  public usuarioAsociar: number;
  public usuarioCliente: number;
  public usuarioClientesAsignados: any[] = [];
  public usuarioFincasAutorizadas: any[] = [];
  public usuarioWeeklyReportLoading = false;
  public usuarioWeeklyReportSaving = false;
  public usuarioWeeklyReportPreviewLoading = false;
  public usuarioWeeklyReportRunLoading = false;
  public usuarioWeeklyReportHtmlLoading = false;
  public usuarioWeeklyReportPdfLoading = false;
  public usuarioWeeklyReportEmailLoading = false;
  public usuarioWeeklyReportErrors: string[] = [];
  public usuarioWeeklyReportPreviewPayload = '';
  public usuarioWeeklyReportRunWeekStart = this.getCurrentWeekStart();
  public usuarioWeeklyReportRunWeekStartDate = this.parseUsuarioWeeklyReportDate(
    this.usuarioWeeklyReportRunWeekStart
  );
  public usuarioWeeklyReportLastRunId: number | null = null;
  public usuarioWeeklyReportSubscriptionId: number | null = null;
  public usuarioWeeklyReportForm = this.getDefaultWeeklyReportForm();
  private usuarioWeeklyReportUsesAllAuthorizedClients = false;
  private usuarioWeeklyReportLegacyModuleIds: number[] = [];
  public readonly usuarioWeeklyReportPlanOptions = [
    {
      value: 'basic',
      labelKey: 'WEEKLY_REPORTS.PLAN_BASIC',
      descriptionKey: 'WEEKLY_REPORTS.PLAN_BASIC_HINT'
    },
    {
      value: 'premium',
      labelKey: 'WEEKLY_REPORTS.PLAN_PREMIUM',
      descriptionKey: 'WEEKLY_REPORTS.PLAN_PREMIUM_HINT'
    }
  ];
  public readonly usuarioWeeklyReportScopeOptions = [
    {
      value: 'selected_clients',
      labelKey: 'WEEKLY_REPORTS.SCOPE_SELECTED_CLIENTS'
    },
    {
      value: 'selected_fincas',
      labelKey: 'WEEKLY_REPORTS.SCOPE_SELECTED_FINCAS'
    }
  ];
  public readonly usuarioWeeklyReportDayOptions = [
    { value: 'MONDAY', labelKey: 'WEEKLY_REPORTS.DAYS.MONDAY' },
    { value: 'TUESDAY', labelKey: 'WEEKLY_REPORTS.DAYS.TUESDAY' },
    { value: 'WEDNESDAY', labelKey: 'WEEKLY_REPORTS.DAYS.WEDNESDAY' },
    { value: 'THURSDAY', labelKey: 'WEEKLY_REPORTS.DAYS.THURSDAY' },
    { value: 'FRIDAY', labelKey: 'WEEKLY_REPORTS.DAYS.FRIDAY' },
    { value: 'SATURDAY', labelKey: 'WEEKLY_REPORTS.DAYS.SATURDAY' },
    { value: 'SUNDAY', labelKey: 'WEEKLY_REPORTS.DAYS.SUNDAY' }
  ];
  public readonly usuarioWeeklyReportLanguageOptions = [
    { value: 'es-ES', labelKey: 'COMMON.LANGUAGES.ES' },
    { value: 'en-US', labelKey: 'COMMON.LANGUAGES.EN' },
    { value: 'fr-FR', labelKey: 'COMMON.LANGUAGES.FR' }
  ];
  public readonly usuarioWeeklyReportTimeOptions =
    this.buildUsuarioWeeklyReportTimeOptions();
  public usuarioWeeklyReportTimezoneOptions: string[] = [];

  public usuarioRoleOptions = [
    { id: 1, label: 'Admin' },
    { id: 2, label: 'Support' },
    { id: 3, label: 'Basic' }
  ];
  public usuarioRolId: number | null = null;
  public usuarioRolIdOriginal: number | null = null;
  public usuarioRoleLoading = false;
  public usuarioRoleError = '';

  public userRoleId: number | null = null;
  public showCreateButton = true;

  public clienteNombre: string;
  public clienteTelefono: string;
  public clienteEmail: string;
  public clienteDireccion: string;
  public clienteCiudad: string;
  public clienteCP: number;
  public clientePais: string;
  public clienteProvincia: string;
  public clienteEmpresa: string;
  public clienteCIF: string;
  public clienteContacto: string;

  public estacionIdExternal: string;
  public estacionLat: number;
  public estacionLng: number;
  public estacionTipo: string;
  public estacionNombre: string;
  public estacionCiudad: string;

  // timezone offset (not used yet)
  public offset = new Date().getTimezoneOffset();

  private mapRoleNameToId(roleName: any): number | null {
    if (!roleName) return null;
    if (roleName === 'Admin') return 1;
    if (roleName === 'Support') return 2;
    if (roleName === 'Basic') return 3;
    return null;
  }

  private pickRoleIdFromRoles(data: any): number | null {
    if (!data) return null;
    let roles = data;
    if (data.roles) roles = data.roles;
    if (data.rolUserList) roles = data.rolUserList;

    if (!Array.isArray(roles)) {
      roles = [roles];
    }

    const ids = roles
      .map(role => {
        if (typeof role === 'number') return role;
        if (typeof role === 'string') return this.mapRoleNameToId(role);
        return (
          role?.idRol ??
          role?.rolId ??
          role?.roleId ??
          role?.rol?.idRol ??
          role?.role?.idRol ??
          this.mapRoleNameToId(role?.name || role?.roleName || role?.role)
        );
      })
      .filter((id: any) => id === 1 || id === 2 || id === 3);

    if (!ids.length) return null;
    return Math.min(...ids);
  }

  private getRoleIdFromUser(user: any): number | null {
    if (!user) return null;
    const direct =
      user.idRol ??
      user.rolId ??
      user.roleId ??
      user.rol?.idRol ??
      user.role?.idRol;
    if (typeof direct === 'number') return direct;

    let roles = user.rolUserList ?? user.roleName ?? user.role;
    if (Array.isArray(roles)) {
      roles = roles[0];
    }
    if (roles && typeof roles === 'object') {
      roles =
        roles?.idRol ??
        roles?.rolId ??
        roles?.roleId ??
        roles?.rol?.idRol ??
        roles?.role?.idRol ??
        roles?.name ??
        roles?.roleName ??
        roles?.role;
    }

    if (typeof roles === 'number') return roles;
    if (typeof roles === 'string') return this.mapRoleNameToId(roles);
    return null;
  }

  private loadUsuarioRoles(idUser: number) {
    this.usuarioRoleLoading = true;
    this.usuarioRoleError = '';
    this.usuarioRolId = null;
    this.usuarioRolIdOriginal = null;

    this.$shttp.default
      .get(`/admin/rol/user/${idUser}`)
      .pipe(
        tap(data => {
          const roleId = this.pickRoleIdFromRoles(data);
          this.usuarioRolId = roleId;
          this.usuarioRolIdOriginal = roleId;
        }),
        catchError(() => {
          this.usuarioRoleError = 'No se pudo cargar el rol.';
          return of(null);
        }),
        finalize(() => (this.usuarioRoleLoading = false))
      )
      .subscribe();
  }

  private updateUsuarioRoleIfNeeded(email: string) {
    const newRole = this.usuarioRolId;
    const oldRole = this.usuarioRolIdOriginal;
    if (newRole === oldRole) {
      return of(null);
    }

    let flow = of(null);
    if (oldRole) {
      flow = flow.pipe(
        concatMap(() =>
          this.$shttp.default.post(`/admin/rolUser/degrade/${oldRole}`, {
            email
          })
        )
      );
    }
    if (newRole) {
      flow = flow.pipe(
        concatMap(() =>
          this.$shttp.default.post(`/admin/rolUser/promote/${newRole}`, {
            email
          })
        )
      );
    }

    return flow.pipe(
      tap(() => {
        this.usuarioRolIdOriginal = newRole;
      }),
      catchError(() => {
        this.snackBar.open(
          this.translateService.instant('SNACKBAR.USER_ROLE_UPDATE_ERROR'),
          this.translateService.instant('COMMON.CLOSE'),
          {
            duration: 3500
          }
        );
        return of(null);
      })
    );
  }

  private dataSource: any[] = [];

  constructor(
    formBuilder: UntypedFormBuilder,
    private aRoute: ActivatedRoute,
    private spinnerSvc: SpinnerService,
    private $config: AdminConfigService,
    private $shttp: SuperHttpClientProvider,
    private translateService: TranslateService,
    private sensorService: SensorService,
    private clientService: ClientService,
    private moduleService: ModuloService,
    private fincaService: FincaService,
    private moistureProfileAdminService: MoistureProfileAdminService,
    private sensorMoistureProfileService: SensorMoistureProfileService,
    private weeklyReportSubscriptionService: WeeklyReportSubscriptionService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {
    this.filterForm = formBuilder.group({
      field: ['', Validators.compose([Validators.required])],
      value: ['', Validators.compose([Validators.required])]
    });
  }

  private openDialog(template: TemplateRef<any>, width = '800px') {
    const ref = this.dialog.open(template, {
      width,
      maxWidth: '95vw',
      disableClose: true,
      autoFocus: false
    });
    this.dialogStack.push(ref);
    this.dialogRef = ref;

    ref
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => {
        this.dialogStack = this.dialogStack.filter(r => r !== ref);
        this.dialogRef = this.dialogStack[this.dialogStack.length - 1];
      });
  }
  ngOnInit() {
    this.usuarioWeeklyReportTimezoneOptions = this.buildTimezoneOptions();
    this.moistureProfileControl.valueChanges.subscribe(value => {
      this.sensorMoistureProfileId = value;
    });

    this.aRoute.params.pipe(map(params => params.name)).subscribe(tableName => {
      this.table = this.$config.getTableByName(tableName);
      this.usuarioCliente = -1;
      this.cliente = -1;
      this.finca = -1;
      if (!!this.table) {
        this.tableColsName = this.table.getColumnsByView('read');
        if (this.table.getName() === 'project_module') {
          const hiddenCols = [
            'latitude',
            'longitude',
            'powerSupplyType',
            'batteryCapacity',
            'aemetCode',
            'deviceMac'
          ];
          this.tableColsName = this.tableColsName.filter(
            col => !hiddenCols.includes(col.getName())
          );
        } else if (this.table.getName() === 'project_finca') {
          const hiddenCols = ['latitude', 'longitude'];
          this.tableColsName = this.tableColsName.filter(
            col => !hiddenCols.includes(col.getName())
          );
        }
        this.availableTableActions();
        this.table.getCriteria().removeFilter(0);
        this.updateCreateVisibility();
        this.refresh();
        this.loadAlarmFincasIfNeeded();
      }
    });

    this.$shttp.default
      .get('/admin/finca')
      .pipe(
        tap(data => {
          this.sensorFincas = data;
          this.moduloFincas = data;
          this.fincas = data;
          this.fincaService.setData(data);
        })
      )
      .subscribe();

    this.loadClientesForUser();

    this.$shttp.default
      .get('/admin/module')
      .pipe(
        tap(data => {
          this.modulos = data;
          this.moduleService.setData(data);
          this.resolveUsuarioWeeklyReportLegacyFincas();
        })
      )
      .subscribe();

    this.sensorService.sensorTypes
      .pipe(
        tap(
          sensorTypes =>
            (this.sensorTypes = this.localizeSensorTypes(sensorTypes))
        )
      )
      .subscribe();

    this.sensorService
      .getSewerSystemTypes()
      .pipe(
        tap(data => {
          this.sewerSystemTypes = data;
          this.sensorDrenaje = data[0].value;
        })
      )
      .subscribe();

    this.sensorService
      .getSensorTypes()
      .pipe(
        tap(types =>
          this.sensorService.sensorTypes.next(this.localizeSensorTypes(types))
        )
      )
      .subscribe();
  }

  public selectedChange(value: number): void {
    this.refresh();
    this.table.getCriteria().changePerPage(value);
  }

  public refresh(): void {
    let name = '';
    let sortField = '';
    if (this.table.getName() === 'project_user') {
      name = 'user';
    } else if (this.table.getName() === 'project_cliente') {
      name = 'cliente';
    } else if (this.table.getName() === 'project_finca') {
      name = 'finca';
    } else if (this.table.getName() === 'project_module') {
      name = 'module';
    } else if (this.table.getName() === 'project_sensor') {
      name = 'sensor';
    } else if (this.table.getName() === 'project_moisture_profile') {
      name = 'moistureProfile';
      sortField = 'updatedOn';
    } else if (this.table.getName() === 'project_station') {
      name = 'station';
    }

    if (!sortField && name) {
      sortField = name + '.isDeleted';
    }

    this.rowsPerpage = [];
    this.spinnerSvc.show();
    const criteria = this.table.getCriteria();
    criteria._sort = sortField ? [{ field: sortField, type: 'ASC' }] : [];

    let request$;
    if (
      this.table.getName() === 'project_moisture_profile' &&
      this.moistureProfileFiltroCliente !== -1
    ) {
      request$ = this.$shttp.default.get(this.table.getUrl(), {
        observe: 'response',
        params: {
          idCliente: String(this.moistureProfileFiltroCliente),
          _perPage: String(criteria._perPage),
          _page: String(criteria._page),
          _sort: JSON.stringify(criteria._sort)
        }
      });
    } else {
      request$ = this.$shttp.default.filter(this.table.getUrl(), criteria, {
        observe: 'response'
      });
    }

    request$.subscribe(
      (response: HttpResponse<any>) => {
        const body = Array.isArray(response.body) ? response.body : [];
        this.totalRows = parseFloat(response.headers.get('x-total-count')) || -1;
        this.tableRows =
          this.table.getName() === 'project_moisture_profile' &&
          this.moistureProfileFiltroCliente !== -1
            ? body.filter(
                row =>
                  Number(row?.idCliente ?? row?.idClient) ===
                  Number(this.moistureProfileFiltroCliente)
              )
            : body;
        if (this.totalRows === -1) {
          this.totalRows = this.tableRows.length;
        }
        this.rowsPerpage.push(this.tableRows);

        this.dataTable();
        this.spinnerSvc.hide();
      },
      () => {
        this.spinnerSvc.hide();
      }
    );
  }

  private updateCreateVisibility(): void {
    const isBasicFinca =
      this.userRoleId === 3 && this.table?.getName() === 'project_finca';
    this.showCreateButton = !isBasicFinca;
    this.updateFincaActions();
  }

  private updateFincaActions(): void {
    if (this.table?.getName() !== 'project_finca') {
      return;
    }
    if (!this.settings || !this.settings.actions) {
      return;
    }
    const isBasic = this.userRoleId === 3;
    this.settings.actions = {
      ...this.settings.actions,
      edit: !isBasic,
      delete: !isBasic
    };
  }

  public dataTable() {
    this.data = [];
    for (const element of this.tableRows) {
      this.data.push(element);
    }

    const columns = {};
    this.tableColsName.forEach(c => {
      if (c.getType() === 'datetime') {
        columns[c.getName()] = {
          title: this.translateService.instant(c.getLabel()),
          editable: c.getIsEditable(),
          filter: c.getIsFilterable(),
          sort: c.getIsSortable(),
          type: 'custom',
          renderComponent: CellDateComponent,
          editor: {
            type: 'custom',
            editable: false,
            component: DatetimepickerComponent
          }
        };
      } else if (c.getType() === 'checkbox') {
        columns[c.getName()] = {
          title: this.translateService.instant(c.getLabel()),
          editable: c.getIsEditable(),
          filter: c.getIsFilterable(),
          sort: c.getIsSortable(),
          type: 'custom',
          renderComponent: BooleanFormatComponent
        };
      } else if (
        this.table.getName() === 'project_module' &&
        c.getName() === 'idFinca'
      ) {
        columns[c.getName()] = {
          editor: {
            type: 'custom',
            editable: false,
            component: SelectfincaComponent
          }
        };
      } else if (
        this.table.getName() === 'project_module' &&
        c.getName() === 'powerSupplyType'
      ) {
        columns[c.getName()] = {
          title: this.translateService.instant(c.getLabel()),
          editable: c.getIsEditable(),
          filter: c.getIsFilterable(),
          sort: c.getIsSortable(),
          type: 'custom',
          renderComponent: ModulePowerSupplyComponent
        };
      } else if (
        this.table.getName() === 'project_user' &&
        c.getName() === 'idCliente'
      ) {
        columns[c.getName()] = {
          title: this.translateService.instant(c.getLabel()),
          editable: c.getIsEditable(),
          filter: c.getIsFilterable(),
          sort: c.getIsSortable(),
          type: 'custom',
          renderComponent: ClientNameComponent
        };
      } else if (
        this.table.getName() === 'project_finca' &&
        c.getName() === 'idCliente'
      ) {
        columns[c.getName()] = {
          title: this.translateService.instant(c.getLabel()),
          editable: c.getIsEditable(),
          filter: c.getIsFilterable(),
          sort: c.getIsSortable(),
          type: 'custom',
          renderComponent: ClienteNameComponent
        };
      } else if (
        this.table.getName() === 'project_sensor' &&
        c.getName() === 'idModule'
      ) {
        columns[c.getName()] = {
          title: this.translateService.instant(c.getLabel()),
          editable: c.getIsEditable(),
          filter: c.getIsFilterable(),
          sort: c.getIsSortable(),
          type: 'custom',
          renderComponent: ModuleNameComponent
        };
      } else if (
        this.table.getName() === 'project_sensor' &&
        c.getName() === 'sensorType'
      ) {
        columns[c.getName()] = {
          title: this.translateService.instant(c.getLabel()),
          editable: c.getIsEditable(),
          filter: c.getIsFilterable(),
          sort: c.getIsSortable(),
          type: 'custom',
          renderComponent: SensorNameComponent
        };
      } else if (
        this.table.getName() === 'project_station' &&
        c.getName() === 'stationType'
      ) {
        columns[c.getName()] = {
          title: this.translateService.instant(c.getLabel()),
          editable: c.getIsEditable(),
          filter: c.getIsFilterable(),
          sort: c.getIsSortable(),
          type: 'custom',
          renderComponent: StationNameComponent
        };
      } else {
        columns[c.getName()] = {
          title: this.translateService.instant(c.getLabel()),
          editable: c.getIsEditable(),
          filter: c.getIsFilterable(),
          sort: c.getIsSortable()
        };
      }
    });

    if (this.table.getName() === 'project_module' && !columns['isDeleted']) {
      columns['isDeleted'] = {
        title: this.translateService.instant(
          'TABLES.PROJECT_MODULE.IS_DELETED'
        ),
        editable: false,
        filter: false,
        sort: true
      };
    }

    const isBasicFinca =
      this.userRoleId === 3 && this.table.getName() === 'project_finca';
    const actions = {
      position: 'right',
      add: false,
      columnTitle: 'Acciones',
      toggle: this.table.getName() === 'project_module',
      alarmFinca: this.table.getName() === 'project_finca',
      edit: !isBasicFinca,
      delete: !isBasicFinca
    };

    this.settings = {
      rowClassFunction: row => {
        if (row.data.isDeleted) {
          return 'deleted';
        } else {
          return 'undeleted';
        }
      },
      actions,
      columns,
      mode: 'external'
    };

    this.updateFincaActions();

    this.settings.pager = {
      display: true,
      perPage: 15
    };

    this.settings.noDataMessage = 'No hay datos para mostrar';
    // Mostrar fila de filtros en la cabecera (similar a la versión original)
    this.settings.hideSubHeader = false;

    if (this.table.getViews().getCanUpdate().length > 0) {
      this.settings.edit = {
        editButtonContent: '<i class="fas fa-pencil-alt"></i>',
        saveButtonContent: '<i class="fas fa-save"></i>',
        cancelButtonContent: '<i class="fas fa-times"></i>',
        confirmSave: true
      };
    } else {
      this.settings.edit = {
        editButtonContent: '',
        saveButtonContent: '',
        cancelButtonContent: ''
      };
    }

    if (this.table.getViews().getCanDelete() === true) {
      this.settings.delete = {
        deleteButtonContent:
          '<i class="fas fa-trash-alt"></i><i class="fa fa-xs fa-undo text-success" aria-hidden="true"></i>',
        confirmDelete: true
      };
    } else {
      this.settings.delete = {
        deleteButtonContent: ''
      };
    }

    this.dataSource = [...this.data];
    this.applyAlarmFlags();
  }

  private loadAlarmFincasIfNeeded(): void {
    if (this.table?.getName() !== 'project_finca') {
      this.alarmFincaIds = new Set<number>();
      return;
    }

    this.$shttp.default
      .get('/user/alarm-finca')
      .pipe(
        map((data: any) => (Array.isArray(data) ? data : [])),
        tap(list => {
          const ids = new Set<number>();
          list.forEach(item => {
            const id = Number(item?.idFinca);
            if (Number.isFinite(id)) {
              ids.add(id);
            }
          });
          this.alarmFincaIds = ids;
          this.applyAlarmFlags();
        }),
        catchError(() => {
          this.alarmFincaIds = new Set<number>();
          this.applyAlarmFlags();
          return of([]);
        })
      )
      .subscribe();
  }

  private applyAlarmFlags(): void {
    if (this.table?.getName() !== 'project_finca') {
      return;
    }
    this.data = (this.data || []).map(row => {
      const id = Number(row?.idFinca);
      if (!Number.isFinite(id)) {
        return row;
      }
      return {
        ...row,
        alarmSubscribed: this.alarmFincaIds.has(id),
        alarmLoading: this.alarmFincaLoading.has(id)
      };
    });
  }

  public onAlarmFinca(event: any): void {
    if (this.table?.getName() !== 'project_finca') {
      return;
    }
    const row = event?.data || event;
    const idFinca = Number(row?.idFinca);
    if (!Number.isFinite(idFinca)) {
      return;
    }
    if (this.alarmFincaLoading.has(idFinca)) {
      return;
    }

    const subscribing = !row?.alarmSubscribed;
    this.alarmFincaLoading.add(idFinca);
    row.alarmLoading = true;

    const request$ = subscribing
      ? this.$shttp.default.post('/user/alarm-finca', { idFinca })
      : this.$shttp.default.delete(`/user/alarm-finca/${idFinca}`);

    request$
      .pipe(
        finalize(() => {
          this.alarmFincaLoading.delete(idFinca);
          row.alarmLoading = false;
          this.applyAlarmFlags();
        })
      )
      .subscribe(
        () => {
          if (subscribing) {
            this.alarmFincaIds.add(idFinca);
          } else {
            this.alarmFincaIds.delete(idFinca);
          }
          row.alarmSubscribed = subscribing;
        },
        () => {
          this.snackBar.open(
            this.translateService.instant('ALARM_FARMS.SUBSCRIPTION_ERROR'),
            this.translateService.instant('COMMON.CLOSE'),
            { duration: 3500 }
          );
        }
      );
  }

  public onToggle(event: any) {
    if (this.table.getName() !== 'project_module') {
      return;
    }
    const row = event?.data || event;
    if (!row || row.idModule === undefined) {
      return;
    }
    const isEnabledKey =
      'isEnabled' in row ? 'isEnabled' : 'isActive' in row ? 'isActive' : null;
    if (!isEnabledKey) {
      return;
    }
    const newValue = !row[isEnabledKey];
    const payload = { ...row, [isEnabledKey]: newValue };
    this.spinnerSvc.show();
    this.$shttp.default
      .put(`/admin/module/${row.idModule}`, payload)
      .pipe(finalize(() => this.spinnerSvc.hide()))
      .subscribe(() => this.refresh());
  }

  // Mostrar usuarios pertenecientes a un determinado cliente
  public usuarioClienteChange() {
    const criteria = this.table.getCriteria();
    const field = 'idCliente';

    const index = criteria._filters.findIndex(
      (_: IFilter) => _.field === field
    );
    if (index !== -1 || this.usuarioCliente === -1) {
      criteria.removeFilter(index);
    }
    if (this.usuarioCliente !== -1) {
      criteria.addFilter({
        field,
        operator: '=',
        value: this.usuarioCliente
      });
    }
    this.refresh();
  }

  // Mostrar fincas pertenecientes a un determinado cliente
  public fincaClienteChange() {
    if (this.table.getName() !== 'project_finca') {
      return;
    }
    const criteria = this.table.getCriteria();
    const field = 'idCliente';

    const index = criteria._filters.findIndex(
      (_: IFilter) => _.field === field
    );
    if (index !== -1 || this.fincaFiltroCliente === -1) {
      criteria.removeFilter(index);
    }
    if (this.fincaFiltroCliente !== -1) {
      criteria.addFilter({
        field,
        operator: '=',
        value: this.fincaFiltroCliente
      });
    }
    this.refresh();
  }

  public moistureProfileClienteChange() {
    if (this.table.getName() !== 'project_moisture_profile') {
      return;
    }
    const criteria = this.table.getCriteria();
    const field = 'idCliente';

    const index = criteria._filters.findIndex(
      (_: IFilter) => _.field === field
    );
    if (index !== -1) {
      criteria.removeFilter(index);
    }
    if (this.moistureProfileFiltroCliente !== -1) {
      criteria.addFilter({
        field,
        operator: '=',
        value: this.moistureProfileFiltroCliente
      });
    }
    this.refresh();
  }

  // Mostrar en el filtro selector, o en el formulario de módulos fincas de ese cliente
  public clienteChange(idCliente: number) {
    const field = 'idCliente';
    if (idCliente === -1) {
      this.criteria.removeFilter(0);
      this.$shttp.default
        .get('/admin/finca')
        .pipe(tap(data => (this.fincas = data)))
        .subscribe();
    } else {
      const index = this.criteria._filters.findIndex(
        (_: IFilter) => _.field === field
      );
      if (index !== -1) {
        this.criteria.removeFilter(index);
      }
      this.criteria.addFilter({
        field: 'idCliente',
        operator: '=',
        value: idCliente
      });
      this.$shttp.default
        .filter('/admin/finca', this.criteria)
        .pipe(
          tap(data => {
            if (this.table.getName() === 'project_module') {
              this.moduloFincas = data;
              if (this.moduloFincas.length !== 0) {
                const targetFinca =
                  this.formTitle === 'Editar' && this.editData?.finca?.idFinca
                    ? this.editData.finca.idFinca
                    : this.moduloFinca !== -1
                    ? this.moduloFinca
                    : null;
                const match = targetFinca
                  ? this.moduloFincas.find(f => f.idFinca === targetFinca)
                  : null;
                this.moduloFinca = match ? match.idFinca : data[0].idFinca;
              } else {
                this.moduloFinca = -1;
              }
            }
            if (this.table.getName() === 'project_sensor') {
              this.sensorFincas = data;
              this.sensorFincaChange();
            }
            this.fincas = data;
            if (this.fincas.length === 0) {
              this.finca = -1;
            }
          })
        )
        .subscribe();
    }
  }

  // Refrescar sensores o módulos por finca
  public fincaChange(idFinca: number) {
    const criteria = this.table.getCriteria();
    let field = '';
    if (this.table.getName() === 'project_sensor') {
      field = 'module.idFinca';
    } else if (this.table.getName() === 'project_module') {
      field = 'idFinca';
    }
    const index = criteria._filters.findIndex(
      (_: IFilter) => _.field === field
    );
    if (index !== -1 || idFinca === -1) {
      criteria.removeFilter(index);
    }
    if (idFinca !== -1) {
      criteria.addFilter({ field, operator: '=', value: idFinca });
    }
    this.refresh();

    // Select filtros módulo en tabla sensores
    if (this.table.getName() === 'project_sensor') {
      // reiniciar filtro módulos
      this.sensorFiltroModulo = -1;
      this.sensorFiltroModuloChange();

      const _criteria = new HttpCriteria({
        _filters: [
          {
            field: 'idFinca',
            operator: '=',
            value: ''
          }
        ],
        _perPage: -1
      });
      const _field = 'idFinca';
      const _index = _criteria._filters.findIndex(
        (_: IFilter) => _.field === _field
      );
      if (_index !== -1) {
        _criteria.removeFilter(_index);
      }
      _criteria.addFilter({
        field: 'idFinca',
        operator: '=',
        value: this.finca
      });
      this.$shttp.default
        .filter('/admin/module', _criteria)
        .pipe(
          tap(data => {
            this.sensorFiltroModulos = data;
            this.moduleService.setData(data);
            if (this.sensorFiltroModulos.length === 0) {
              this.sensorFiltroModulo = -1;
            }
          })
        )
        .subscribe();
    }
  }

  // Cambio de módulo en filtro de sensores de la tabla
  public sensorFiltroModuloChange() {
    const criteria = this.table.getCriteria();
    let finca = '';
    let module = '';
    if (this.table.getName() === 'project_sensor') {
      finca = 'module.idFinca';
      module = 'module.idModule';
    }
    const index = criteria._filters.findIndex(
      (_: IFilter) => _.field === finca
    );
    if (index !== -1 || this.finca === -1) {
      criteria.removeFilter(index);
    }
    if (this.finca !== -1) {
      criteria.addFilter({ field: finca, operator: '=', value: this.finca });
    }

    const index2 = criteria._filters.findIndex(
      (_: IFilter) => _.field === module
    );
    if (index2 !== -1 || this.sensorFiltroModulo === -1) {
      criteria.removeFilter(index2);
    }
    if (this.sensorFiltroModulo !== -1) {
      criteria.addFilter({
        field: module,
        operator: '=',
        value: this.sensorFiltroModulo
      });
    }
    this.refresh();
  }

  // Mostrar fincas en el formulario de sensor
  public sensorClienteChange(idCliente: number) {
    const field = 'idCliente';
    const index = this.criteria._filters.findIndex(
      (_: IFilter) => _.field === field
    );

    if (index !== -1) {
      this.criteria.removeFilter(index);
    }

    this.criteria.addFilter({
      field: 'idCliente',
      operator: '=',
      value: idCliente
    });

    this.$shttp.default
      .filter('/admin/finca', this.criteria)
      .pipe(
        tap(data => {
          this.sensorFincas = data;
          if (this.sensorFincas.length === 0) {
            this.sensorFinca = -1;
          } else {
            const targetFinca =
              (this.formTitle === 'Editar' &&
                this.editData?.module?.finca?.idFinca) ||
              (this.sensorFinca !== -1 ? this.sensorFinca : null);
            const match = targetFinca
              ? this.sensorFincas.find(f => f.idFinca === targetFinca)
              : null;
            this.sensorFinca = match
              ? match.idFinca
              : this.sensorFincas[0].idFinca;
          }
        }),
        finalize(() => this.sensorFincaChange())
      )
      .subscribe();
  }

  // Mostrar módulos en el formulario de sensor
  public sensorFincaChange() {
    const criteria = new HttpCriteria({
      _filters: [
        {
          field: 'idFinca',
          operator: '=',
          value: ''
        }
      ],
      _perPage: -1
    });

    const field = 'idFinca';
    const index = criteria._filters.findIndex(
      (_: IFilter) => _.field === field
    );

    if (index !== -1) {
      criteria.removeFilter(index);
    }

    criteria.addFilter({
      field: 'idFinca',
      operator: '=',
      value: this.sensorFinca
    });

    this.$shttp.default
      .filter('/admin/module', criteria)
      .pipe(
        tap(data => {
          this.modulos = data;
          if (this.modulos.length === 0) {
            this.sensorModulo = -1;
          } else {
            const targetModulo =
              (this.formTitle === 'Editar' &&
                this.editData?.module?.idModule) ||
              (this.sensorModulo !== -1 ? this.sensorModulo : null);
            const match = targetModulo
              ? this.modulos.find(m => m.idModule === targetModulo)
              : null;
            this.sensorModulo = match
              ? match.idModule
              : this.modulos[0].idModule;
          }
        })
      )
      .subscribe();
  }

  public isMoistureProfileValid(): boolean {
    const name = (this.moistureProfileName || '').trim();
    const hasClient =
      this.moistureProfileCliente !== null &&
      this.moistureProfileCliente !== -1;
    return name.length > 0 && name.length <= 100 && hasClient;
  }

  private loadMoistureSeasons(profileId: number) {
    if (!profileId) {
      this.moistureProfileSeasons = [];
      return;
    }
    const idCliente = this.moistureProfileCliente ?? undefined;
    this.moistureProfileAdminService
      .listSeasons(profileId, idCliente !== -1 ? idCliente : undefined)
      .pipe(tap(data => (this.moistureProfileSeasons = data || [])))
      .subscribe();
  }

  public openMoistureSeasonCreate() {
    if (!this.moistureProfileId) return;
    this.seasonFormTitle = 'Crear';
    this.seasonId = null;
    this.seasonName = '';
    this.seasonStartMmdd = '';
    this.seasonEndMmdd = '';
    this.seasonStartDate = null;
    this.seasonEndDate = null;
    this.seasonThreshold1 = 0;
    this.seasonThreshold2 = 0;
    this.seasonPriority = 0;
    this.seasonEnabled = true;
    this.seasonError = '';
    this.openDialog(this.moistureSeasonForm, '720px');
  }

  public openMoistureSeasonEdit(season: any) {
    if (!this.moistureProfileId || !season) return;
    this.seasonFormTitle = 'Editar';
    this.seasonId = season.id ?? season.idMoistureProfileSeason;
    this.seasonName = season.name || '';
    this.seasonStartMmdd = season.startMmdd || '';
    this.seasonEndMmdd = season.endMmdd || '';
    this.seasonStartDate = this.mmddToDate(this.seasonStartMmdd);
    this.seasonEndDate = this.mmddToDate(this.seasonEndMmdd);
    this.seasonThreshold1 = Number(season.threshold1 ?? 0);
    this.seasonThreshold2 = Number(season.threshold2 ?? 0);
    this.seasonPriority = Number(season.priority ?? 0);
    this.seasonEnabled = !!season.isEnabled;
    this.seasonError = '';
    this.openDialog(this.moistureSeasonForm, '720px');
  }

  private getSeasonValidationError(): string | null {
    const name = (this.seasonName || '').trim();
    if (!name) return 'Nombre requerido';
    if (!this.seasonStartMmdd || !this.mmddRegex.test(this.seasonStartMmdd)) {
      return 'Inicio debe tener formato MM-DD';
    }
    if (!this.seasonEndMmdd || !this.mmddRegex.test(this.seasonEndMmdd)) {
      return 'Fin debe tener formato MM-DD';
    }
    const t1 = Number(this.seasonThreshold1);
    const t2 = Number(this.seasonThreshold2);
    if (!Number.isFinite(t1) || t1 < 0 || t1 > 100) {
      return 'Umbral 1 debe estar entre 0 y 100';
    }
    if (!Number.isFinite(t2) || t2 < 0 || t2 > 100) {
      return 'Umbral 2 debe estar entre 0 y 100';
    }
    if (t1 > t2) return 'Umbral 1 debe ser menor o igual que Umbral 2';
    return null;
  }

  public isSeasonValid(): boolean {
    return !this.getSeasonValidationError();
  }

  private toMmdd(value: Date | null): string {
    if (!value) return '';
    const month = value.getMonth() + 1;
    const day = value.getDate();
    const mm = month < 10 ? `0${month}` : String(month);
    const dd = day < 10 ? `0${day}` : String(day);
    return `${mm}-${dd}`;
  }

  private mmddToDate(mmdd: string): Date | null {
    if (!mmdd || !this.mmddRegex.test(mmdd)) return null;
    const [mm, dd] = mmdd.split('-').map(value => Number(value));
    if (!mm || !dd) return null;
    const date = new Date();
    date.setMonth(mm - 1, dd);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  public onSeasonStartDateChange(value: Date | null) {
    this.seasonStartDate = value;
    this.seasonStartMmdd = this.toMmdd(value);
  }

  public onSeasonEndDateChange(value: Date | null) {
    this.seasonEndDate = value;
    this.seasonEndMmdd = this.toMmdd(value);
  }

  public moistureSeasonSave() {
    const error = this.getSeasonValidationError();
    if (error) {
      this.seasonError = error;
      return;
    }
    if (!this.moistureProfileId) return;

    const payload: any = {
      name: (this.seasonName || '').trim(),
      startMmdd: this.seasonStartMmdd,
      endMmdd: this.seasonEndMmdd,
      threshold1: Number(this.seasonThreshold1),
      threshold2: Number(this.seasonThreshold2),
      priority: Number(this.seasonPriority) || 0,
      isEnabled: !!this.seasonEnabled
    };
    if (this.formTitle === 'Editar' && this.seasonId) {
      payload.idMoistureProfileSeason = this.seasonId;
    }
    const idCliente = this.moistureProfileCliente ?? undefined;
    const req$ =
      this.seasonFormTitle === 'Editar' && this.seasonId
        ? this.moistureProfileAdminService.updateSeason(
            this.seasonId,
            payload,
            idCliente !== -1 ? idCliente : undefined
          )
        : this.moistureProfileAdminService.createSeason(
            this.moistureProfileId,
            payload,
            idCliente !== -1 ? idCliente : undefined
          );

    req$
      .pipe(finalize(() => this.loadMoistureSeasons(this.moistureProfileId)))
      .subscribe(() => this.closeDialog());
  }

  public deleteMoistureSeason(season: any) {
    const seasonId = season?.id ?? season?.idMoistureProfileSeason;
    if (!seasonId) return;
    this.openDeleteSeasonConfirm(seasonId);
  }

  private openDeleteSeasonConfirm(seasonId: number) {
    this.pendingSeasonDeleteId = seasonId;
    this.confirmTitleKey = 'COMMON.CONFIRM_TITLE';
    this.confirmMessageKey = 'COMMON.CONFIRM_DELETE_SEASON';
    this.confirmActionKey = 'COMMON.DELETE';
    this.confirmCancelKey = 'COMMON.CANCEL';
    this.openDialog(this.confirmDialog, '420px');
  }

  public confirmDeleteSeason() {
    const seasonId = this.pendingSeasonDeleteId;
    this.pendingSeasonDeleteId = null;
    this.closeDialog();
    if (!seasonId) return;
    const idCliente = this.moistureProfileCliente ?? undefined;
    this.moistureProfileAdminService
      .deleteSeason(seasonId, idCliente !== -1 ? idCliente : undefined)
      .pipe(finalize(() => this.loadMoistureSeasons(this.moistureProfileId)))
      .subscribe();
  }

  public moistureProfileSave() {
    if (!this.isMoistureProfileValid()) return;
    const payload: any = { name: (this.moistureProfileName || '').trim() };
    if (
      this.moistureProfileCliente !== -1 &&
      this.moistureProfileCliente !== null
    ) {
      payload.idCliente = this.moistureProfileCliente;
    }
    if (this.formTitle === 'Crear') {
      this.moistureProfileAdminService
        .createProfile(payload)
        .pipe(finalize(() => this.refresh()))
        .subscribe();
    } else if (this.formTitle === 'Editar' && this.moistureProfileId) {
      this.moistureProfileAdminService
        .updateProfile(this.moistureProfileId, payload)
        .pipe(finalize(() => this.refresh()))
        .subscribe();
    }
  }

  public create() {
    this.formTitle = 'Crear';
    if (this.table.getName() === 'project_user') {
      this.openDialog(this.usuarioForm, '1100px');
      this.usuarioNombre = '';
      this.resetUsuarioWeeklyReportState();
    }

    if (this.table.getName() === 'project_cliente') {
      this.openDialog(this.clienteForm);
      this.clienteNombre = '';
      this.clienteContacto = '';
      this.clienteTelefono = '';
      this.clienteEmail = '';
      this.clienteDireccion = '';
      this.clienteCiudad = '';
      this.clienteCP = 46002;
      this.clientePais = 'España';
      this.clienteProvincia = 'Valencia';
      this.clienteEmpresa = '';
      this.clienteCIF = '';
    }

    if (this.table.getName() === 'project_finca') {
      this.openDialog(this.fincaForm, '900px');
      this.fincaCliente = this.moduloFincas[0].idFinca;
      this.fincaNombre = '';
      this.fincaPoblacion = '';
      this.fincaLat = 0;
      this.fincaLng = 0;
    }

    if (this.table.getName() === 'project_module') {
      this.openDialog(this.moduloForm, '900px');
      this.moduloCliente = this.cliente;
      this.clienteChange(this.moduloCliente);
      if (this.finca !== -1) {
        this.moduloFinca = this.finca;
      }
      this.moduloNombre = '';
      this.moduloLat = 0;
      this.moduloLng = 0;
      this.moduloMac = '0';
      this.moduloPower = 'BA';
      this.moduloBateria = 5;
      this.moduloAemetCode = null;
    }

    if (this.table.getName() === 'project_sensor') {
      this.openDialog(this.sensorForm, '900px');
      this.sensorCliente = this.cliente;
      this.clienteChange(this.sensorCliente);
      if (this.sensorFiltroModulo !== -1) {
        this.sensorModulo = this.sensorFiltroModulo;
      } else {
        this.sensorModulo = this.modulos[0].idModule;
      }
      if (this.finca !== -1) {
        this.sensorFinca = this.finca;
      } else {
        this.sensorFinca = this.sensorFincas[0].idFinca;
      }
      this.sensorAlarma = false;
      this.sensorMin = 0;
      this.sensorMax = 0;
      this.sensorTipo = this.sensorTypes[0].value;
      this.moistureProfiles = [];
      this.sensorMoistureProfileId = null;
      this.moistureProfileControl.setValue(null);
    }

    if (this.table.getName() === 'project_moisture_profile') {
      this.openDialog(this.moistureProfileForm, '900px');
      this.moistureProfileId = null;
      this.moistureProfileName = '';
      this.moistureProfileCliente =
        this.moistureProfileFiltroCliente !== -1
          ? this.moistureProfileFiltroCliente
          : this.cliente ?? -1;
      this.moistureProfileSeasons = [];
    }

    if (this.table.getName() === 'project_station') {
      this.openDialog(this.estacionForm, '900px');
      this.estacionLat = 0;
      this.estacionLng = 0;
      this.estacionTipo = 'AEMET';
      this.estacionNombre = '';
      this.estacionCiudad = '';
      this.estacionIdExternal = '';
    }
  }

  public edit(event: any) {
    this.formTitle = 'Editar';
    this.editData = event.data;

    if (this.table.getName() === 'project_user') {
      this.openDialog(this.usuarioForm, '1100px');
      this.usuarioNombre = this.editData.telegramUsername;
      this.loadUsuarioRoles(this.editData.idUser);
      this.usuarioClientesAsignados = [];
      this.loadUsuarioClientes(this.editData.idUser);
      this.usuarioAsociar = -1;
      this.loadUsuarioWeeklyReport(this.editData.idUser);
    }

    if (this.table.getName() === 'project_cliente') {
      this.openDialog(this.clienteForm);
      this.clienteNombre = this.editData.name;
      this.clienteContacto = this.editData.contactPersonName;
      this.clienteTelefono = this.editData.contactPersonPhone;
      this.clienteEmail = this.editData.contactPersonEmail;
      this.clienteDireccion = this.editData.address;
      this.clienteCiudad = this.editData.city;
      this.clienteCP = this.editData.postalCode;
      this.clientePais = this.editData.country;
      this.clienteProvincia = this.editData.state;
      this.clienteEmpresa = this.editData.companyName;
      this.clienteCIF = this.editData.taxId;
    }

    if (this.table.getName() === 'project_finca') {
      this.openDialog(this.fincaForm, '900px');
      this.fincaCliente = this.editData.idCliente;
      this.fincaNombre = this.editData.name;
      this.fincaPoblacion = this.editData.city;
      this.fincaLat = this.editData.latitude;
      this.fincaLng = this.editData.longitude;
    }

    if (this.table.getName() === 'project_module') {
      this.clienteChange(this.editData.finca.idCliente);
      this.openDialog(this.moduloForm, '900px');
      this.moduloCliente = this.editData.finca.idCliente;
      this.moduloFinca = this.editData.finca.idFinca;
      this.moduloNombre = this.editData.name;
      this.moduloLat = this.editData.latitude;
      this.moduloLng = this.editData.longitude;
      this.moduloMac = this.editData.deviceMac;
      this.moduloPower = this.editData.powerSupplyType;
      this.moduloBateria = this.editData.batteryCapacity;
      this.moduloAemetCode = this.editData.aemetCode;
    }

    if (this.table.getName() === 'project_sensor') {
      this.clienteChange(this.editData.module.finca.idCliente);
      this.openDialog(this.sensorForm, '900px');
      this.sensorCliente = this.editData.module.finca.idCliente;
      this.sensorFinca = this.editData.module.finca.idFinca;
      this.sensorModulo = this.editData.module.idModule;
      this.sensorAlarma = this.editData.isAlarmEnabled;
      this.sensorMin = this.editData.minimun;
      this.sensorMax = this.editData.maximun;
      this.sensorTipo = this.editData.sensorType;
      this.moistureProfiles = [];
      this.sensorMoistureProfileId = null;
      this.moistureProfileControl.setValue(null, { emitEvent: false });

      if (this.isMoistureSensorType(this.sensorTipo)) {
        const profileClientId =
          this.sensorCliente !== -1 ? this.sensorCliente : undefined;
        this.sensorMoistureProfileService
          .listProfiles(profileClientId)
          .pipe(
            tap(profiles => {
              const list = profiles || [];
              if (
                profileClientId &&
                list.some(
                  (p: any) =>
                    p?.idCliente !== undefined || p?.idClient !== undefined
                )
              ) {
                this.moistureProfiles = list.filter(
                  (p: any) =>
                    p?.idCliente === profileClientId ||
                    p?.idClient === profileClientId
                );
              } else {
                this.moistureProfiles = list;
              }
            }),
            switchMap(() =>
              this.sensorMoistureProfileService.getSensorProfile(
                this.editData.idSensor
              )
            ),
            tap((data: any) => {
              const profileId = data?.profileId ?? null;
              this.sensorMoistureProfileId = profileId;
              this.moistureProfileControl.setValue(profileId, {
                emitEvent: false
              });
            }),
            catchError(() => {
              this.moistureProfiles = [];
              this.sensorMoistureProfileId = null;
              this.moistureProfileControl.setValue(null, {
                emitEvent: false
              });
              return of(null);
            })
          )
          .subscribe();
      }
    }

    if (this.table.getName() === 'project_moisture_profile') {
      this.openDialog(this.moistureProfileForm, '900px');
      this.moistureProfileId =
        this.editData.idMoistureProfile ?? this.editData.id;
      this.moistureProfileName = this.editData.name;
      this.moistureProfileCliente =
        this.editData.idCliente ?? this.cliente ?? -1;
      this.loadMoistureSeasons(this.moistureProfileId);
    }

    if (this.table.getName() === 'project_station') {
      this.openDialog(this.estacionForm, '900px');
      this.estacionLat = this.editData.latitude;
      this.estacionLng = this.editData.longitude;
      this.estacionTipo = this.editData.stationType;
      this.estacionIdExternal = this.editData.id;
      this.estacionNombre = this.editData.name;
      this.estacionCiudad = this.editData.city;
    }
  }

  saveOrEdit(object: any, type?: 'cliente' | 'finca' | 'modulo') {
    if (this.formTitle === 'Crear') {
      this.$shttp.default.post(this.table.getUrl(), object).subscribe(() => {
        this.refresh();
        if (type === 'cliente') {
          this.loadClientesForUser();
        } else if (type === 'finca') {
          this.$shttp.default
            .get('/admin/finca')
            .pipe(
              tap(data => {
                this.moduloFincas = data;
                this.fincas = data;
                this.fincaService.setData(data);
              })
            )
            .subscribe();
        } else if (type === 'modulo') {
          this.$shttp.default
            .get('/admin/module')
            .pipe(
              tap(data => {
                this.modulos = data;
                this.moduleService.setData(data);
              })
            )
            .subscribe();
        }
      });
    } else if (this.formTitle === 'Editar') {
      this.$shttp.default
        .put(
          `${this.table.getUrl()}/${
            this.editData[this.table.getColumnId().getName()]
          }`,
          object
        )
        .pipe(
          finalize(() => {
            this.refresh();
            if (type === 'cliente') {
              this.$shttp.default
                .get('/admin/cliente')
                .pipe(
                  tap(data => {
                    this.clientes = data;
                    this.clientService.setData(data);
                  })
                )
                .subscribe();
            } else if (type === 'finca') {
              this.$shttp.default
                .get('/admin/finca')
                .pipe(
                  tap(data => {
                    this.moduloFincas = data;
                    this.fincas = data;
                    this.fincaService.setData(data);
                  })
                )
                .subscribe();
            } else if (type === 'modulo') {
              this.$shttp.default
                .get('/admin/module')
                .pipe(
                  tap(data => {
                    this.modulos = data;
                    this.moduleService.setData(data);
                  })
                )
                .subscribe();
            }
          })
        )
        .subscribe();
    }
  }

  public sensorSave() {
    const sensorType = this.sensorTipo ?? this.sensorTypes?.[0]?.value;
    let sensor;
    if (this.formTitle === 'Crear') {
      sensor = {
        idModule: this.sensorModulo,
        isAlarmEnabled: this.sensorAlarma,
        sensorType,
        minimun: this.sensorMin,
        maximun: this.sensorMax
      };
      this.saveOrEdit(sensor);
      return;
    }

    if (this.formTitle === 'Editar') {
      sensor = {
        idSensor: this.editData.idSensor,
        idModule: this.sensorModulo,
        isAlarmEnabled: this.sensorAlarma,
        minimun: this.sensorMin,
        maximun: this.sensorMax
      };

      if (this.isMoistureSensorType(this.sensorTipo)) {
        const url = `${this.table.getUrl()}/${
          this.editData[this.table.getColumnId().getName()]
        }`;
        this.$shttp.default
          .put(url, sensor)
          .pipe(
            concatMap(() =>
              this.sensorMoistureProfileService
                .setSensorProfile(
                  this.editData.idSensor,
                  this.sensorMoistureProfileId
                )
                .pipe(
                  catchError(() => {
                    this.snackBar.open(
                      'No se pudo guardar el perfil de humedad.',
                      'Cerrar',
                      { duration: 3500 }
                    );
                    return of(null);
                  })
                )
            ),
            finalize(() => this.refresh())
          )
          .subscribe();
        return;
      }
    }

    this.saveOrEdit(sensor);
  }

  public eventSave() {
    this.spinnerSvc.show();
    const anyo = this.eventModuleForm.get('date').value.split('-')[0];
    const mes = this.eventModuleForm.get('date').value.split('-')[1];
    const dia = this.eventModuleForm.get('date').value.split('-')[2];
    const timeStr = this.eventModuleForm.get('time').value || '00:00';
    const [hStr, mStr] = timeStr.split(':');
    const hora = Number(hStr);
    const minuto = Number(mStr);
    const segundos = '00';

    let tiempo = '';

    tiempo = 'T' + ('0' + hora).slice(-2) + ('0' + minuto).slice(-2) + segundos;
    console.log('TIEMPO --> ', tiempo);

    const fecha = anyo.concat(mes, dia, tiempo, '+00:00');

    const item = {
      idModule: this.eventModuleForm.get('idModule').value,
      date: fecha,
      comment: this.eventModuleForm.get('comment').value
    };

    this.$shttp.default
      .post('/admin/event', item)
      .pipe(
        finalize(() => {
          this.moduleService
            .getEventsByModule(this.editData.idModule)
            .pipe(
              tap(data => {
                this.events = data;

                const date = '';
                const time = '';

                for (const element of this.events) {
                  const fechaTroceada = element.date.split('');
                  const _fecha = date.concat(
                    fechaTroceada[0],
                    fechaTroceada[1],
                    fechaTroceada[2],
                    fechaTroceada[3],
                    '-',
                    fechaTroceada[4],
                    fechaTroceada[5],
                    '-',
                    fechaTroceada[6],
                    fechaTroceada[7]
                  );
                  element.date = _fecha;

                  const hour = time.concat(fechaTroceada[9], fechaTroceada[10]);
                  const minutes = time.concat(
                    fechaTroceada[11],
                    fechaTroceada[12]
                  );
                  const second = time.concat(
                    fechaTroceada[13],
                    fechaTroceada[14]
                  );

                  element.time = {
                    hour: parseFloat(hour),
                    minute: parseFloat(minutes),
                    second: parseFloat(second)
                  };
                }
              })
            )
            .subscribe();
        })
      )
      .subscribe();
  }

  public eventUpdate(event: any) {
    this.spinnerSvc.show();
    let anyo;
    let mes;
    let dia;
    let hora;
    let minuto;
    let segundos;
    let tiempo;
    let fecha;

    if (event.date !== null && event.time !== null) {
      anyo = event.date.split('-')[0];
      mes = event.date.split('-')[1];
      dia = event.date.split('-')[2];
      const [hStr, mStr] = (event.time || '00:00').split(':');
      hora = Number(hStr);
      minuto = Number(mStr);
      segundos = '00';
      tiempo =
        'T' + ('0' + hora).slice(-2).concat(('0' + minuto).slice(-2), segundos);
      fecha = anyo.concat(mes, dia, tiempo, '+00:00');
    } else if (event.date !== null) {
      anyo = event.date.split('-')[0];
      mes = event.date.split('-')[1];
      dia = event.date.split('-')[2];
      fecha = anyo.concat(mes, dia, '+00:00');
    } else if (event.time !== null) {
      const [hStr, mStr] = (event.time || '00:00').split(':');
      hora = Number(hStr);
      minuto = Number(mStr);
      segundos = '00';
      tiempo =
        'T' + ('0' + hora).slice(-2).concat(('0' + minuto).slice(-2), segundos);
      fecha = anyo.concat(tiempo, '+00:00');
    }

    const item = {
      idEvent: event.idEvent,
      idModule: event.idModule,
      date: fecha,
      comment: event.comment
    };

    this.$shttp.default
      .put(`/admin/event/${event.idEvent}`, item)
      .pipe(
        finalize(() => {
          this.moduleService
            .getEventsByModule(this.editData.idModule)
            .pipe(
              tap(data => {
                this.events = data;

                const date = '';
                const time = '';

                for (const element of this.events) {
                  const fechaTroceada = element.date.split('');
                  const _fecha = date.concat(
                    fechaTroceada[0],
                    fechaTroceada[1],
                    fechaTroceada[2],
                    fechaTroceada[3],
                    '-',
                    fechaTroceada[4],
                    fechaTroceada[5],
                    '-',
                    fechaTroceada[6],
                    fechaTroceada[7]
                  );
                  element.date = _fecha;

                  const hour = time.concat(fechaTroceada[9], fechaTroceada[10]);
                  const minutes = time.concat(
                    fechaTroceada[11],
                    fechaTroceada[12]
                  );
                  const second = time.concat(
                    fechaTroceada[13],
                    fechaTroceada[14]
                  );

                  element.time = {
                    hour: parseFloat(hour),
                    minute: parseFloat(minutes),
                    second: parseFloat(second)
                  };
                }
              })
            )
            .subscribe();
        })
      )
      .subscribe();
  }

  public eventDelete(idEvent: number) {
    this.spinnerSvc.show();
    this.$shttp.default
      .delete(`/admin/event/${idEvent}`)
      .pipe(
        finalize(() => {
          this.moduleService
            .getEventsByModule(this.editData.idModule)
            .pipe(
              tap(data => {
                this.events = data;

                const date = '';
                const time = '';

                for (const element of this.events) {
                  const fechaTroceada = element.date.split('');
                  const fecha = date.concat(
                    fechaTroceada[0],
                    fechaTroceada[1],
                    fechaTroceada[2],
                    fechaTroceada[3],
                    '-',
                    fechaTroceada[4],
                    fechaTroceada[5],
                    '-',
                    fechaTroceada[6],
                    fechaTroceada[7]
                  );
                  element.date = fecha;

                  const hour = time.concat(fechaTroceada[9], fechaTroceada[10]);
                  const minutes = time.concat(
                    fechaTroceada[11],
                    fechaTroceada[12]
                  );
                  const second = time.concat(
                    fechaTroceada[13],
                    fechaTroceada[14]
                  );

                  element.time = {
                    hour: parseFloat(hour),
                    minute: parseFloat(minutes),
                    second: parseFloat(second)
                  };
                }
              }),
              finalize(() => this.spinnerSvc.hide())
            )
            .subscribe();
        })
      )
      .subscribe();
  }

  // Open sensor settings form
  public openSensorSettings() {
    this.spinnerSvc.show();
    this.sensorService
      .getSensorSettings(this.editData.idSensor)
      .pipe(
        tap(sensorSettings => {
          this.spinnerSvc.hide();
          this.saveSensorDates(sensorSettings);
          this.sensorSettings = sensorSettings;
          this.openDialog(this.sensorSettingsForm, '90vw');
        })
      )
      .subscribe();
  }

  public openModuleSettings() {
    this.moduleService.data$.subscribe(data => {});

    this.eventModuleForm.get('idModule').setValue(this.editData.idModule);

    this.moduleService
      .getEventsByModule(this.editData.idModule)
      .pipe(
        tap(data => {
          this.events = data;

          const date = '';
          const time = '';

          for (const element of this.events) {
            const fechaTroceada = element.date.split('');
            const fecha = date.concat(
              fechaTroceada[0],
              fechaTroceada[1],
              fechaTroceada[2],
              fechaTroceada[3],
              '-',
              fechaTroceada[4],
              fechaTroceada[5],
              '-',
              fechaTroceada[6],
              fechaTroceada[7]
            );
            element.date = fecha;

            const hour = time.concat(fechaTroceada[9], fechaTroceada[10]);
            const minutes = time.concat(fechaTroceada[11], fechaTroceada[12]);
            const second = time.concat(fechaTroceada[13], fechaTroceada[14]);

            element.time = {
              hour: parseFloat(hour),
              minute: parseFloat(minutes),
              second: parseFloat(second)
            };
          }
        })
      )
      .subscribe();

    setTimeout(() => {
      this.openDialog(this.eventForm, '90vw');
    }, 1000);
  }

  // Transform string date to Date to display
  public saveSensorDates(data: any) {
    this.sensorSettingsDates = [];
    this.sensorSettingsTimes = [];
    for (const { instant } of data) {
      if (instant) {
        const year = instant.slice(0, 4);
        const month = instant.slice(4, 6);
        const day = instant.slice(6, 8);
        const hour = instant.slice(9, 11);
        const minute = instant.slice(11, 13);
        this.sensorSettingsDates.push(
          new Date(
            Number(year),
            Number(month) - 1,
            Number(day),
            Number(hour),
            Number(minute),
            0
          )
        );
        this.sensorSettingsTimes.push(
          `${('0' + hour).slice(-2)}:${('0' + minute).slice(-2)}`
        );
      }
    }
  }

  // Save sensor settings
  public saveSensorSetting(position: number) {
    // Transform Date to string and send to server
    const sensorSettingsDate = this.sensorSettingsDates[position];
    const sensorSettingsTime = this.sensorSettingsTimes[position];

    if (sensorSettingsDate && sensorSettingsTime) {
      this.spinnerSvc.show();
      // Date to string yyyyMMddTHHmm00
      const [hStr, mStr] = (sensorSettingsTime || '00:00').split(':');
      this.sensorSettings[position].instant =
        sensorSettingsDate.getFullYear().toString() +
        ('0' + (sensorSettingsDate.getMonth() + 1)).slice(-2) +
        ('0' + sensorSettingsDate.getDate()).slice(-2) +
        'T' +
        ('0' + Number(hStr)).slice(-2) +
        ('0' + Number(mStr)).slice(-2) +
        '00';
      // Round 2 decimals
      if (
        this.sensorSettings[position].calibration !== undefined &&
        this.sensorSettings[position].calibration !== null &&
        this.sensorSettings[position].calibration !== ''
      ) {
        const calibration = parseFloat(
          this.sensorSettings[position].calibration
        );
        if (Number.isFinite(calibration)) {
          this.sensorSettings[position].calibration = calibration.toFixed(2);
        }
      }
      if (
        this.sensorSettings[position].co_permitivity !== undefined &&
        this.sensorSettings[position].co_permitivity !== null &&
        this.sensorSettings[position].co_permitivity !== ''
      ) {
        const permitivity = parseFloat(
          this.sensorSettings[position].co_permitivity
        );
        if (Number.isFinite(permitivity)) {
          this.sensorSettings[position].co_permitivity = permitivity.toFixed(2);
        }
      }
      if (this.sensorSettings[position].hu_sewerSystemType !== undefined) {
        this.sensorSettings[
          position
        ].hu_sewerSystemType = this.normalizeSewerSystemType(
          this.sensorSettings[position].hu_sewerSystemType
        );
      }

      this.sensorService
        .updateSensorSetting(
          this.sensorSettings[position].idSettings,
          this.sensorSettings[position]
        )
        .pipe(
          finalize(() => {
            this.sensorService
              .getSensorSettings(this.editData.idSensor)
              .pipe(
                tap(sensorSettings => {
                  this.sensorSettings = sensorSettings;
                }),
                finalize(() => this.spinnerSvc.hide())
              )
              .subscribe();
          })
        )
        .subscribe();
    }
  }

  public deleteSensorSetting(position: number) {
    this.spinnerSvc.show();
    this.sensorService
      .deleteSensorSetting(position)
      .pipe(
        finalize(() => {
          this.sensorService
            .getSensorSettings(this.editData.idSensor)
            .pipe(
              tap(sensorSettings => {
                this.sensorSettings = sensorSettings;
                this.saveSensorDates(sensorSettings);
              }),
              finalize(() => this.spinnerSvc.hide())
            )
            .subscribe();
        })
      )
      .subscribe();
  }

  private normalizeSewerSystemType(value: any): string {
    const options = this.getAvailableSewerSystemTypeValues(
      this.editData?.sensorType ?? this.sensorTipo
    );
    const raw = typeof value === 'string' ? value : '';
    if (raw && options.includes(raw)) {
      return raw;
    }
    if (options.includes('H10')) {
      return 'H10';
    }
    return options[0] || 'H10';
  }

  public isMoistureSensorType(sensorType: string | undefined): boolean {
    return ['HU', 'E8', 'SH', 'SC'].includes(
      String(sensorType || '').toUpperCase()
    );
  }

  public isEnviroproSensorType(sensorType: string | undefined): boolean {
    return String(sensorType || '').toUpperCase() === 'E8';
  }

  public isSingleSoilHumiditySensorType(sensorType: string | undefined): boolean {
    return ['SH', 'SC'].includes(String(sensorType || '').toUpperCase());
  }

  public getHumidityDepthLabels(sensorType: string | undefined): string[] {
    if (this.isSingleSoilHumiditySensorType(sensorType)) {
      return [this.translateService.instant('STATICS.SERIES.SOIL_MOISTURE')];
    }

    return this.isEnviroproSensorType(sensorType)
      ? ['H10', 'H20', 'H30', 'H40', 'H50', 'H60', 'H70', 'H80']
      : ['H10', 'H20', 'H30', 'H40', 'H50', 'H60'];
  }

  public getAvailableSewerSystemTypes(sensorType: string | undefined): any[] {
    const list = Array.isArray(this.sewerSystemTypes) ? this.sewerSystemTypes : [];
    if (!this.isSingleSoilHumiditySensorType(sensorType)) {
      return list;
    }
    const filtered = list.filter((item: any) => item?.value === 'H10');
    return filtered.length ? filtered : [{ value: 'H10' }];
  }

  public getSewerSystemTypeLabel(
    sensorType: string | undefined,
    value: string
  ): string {
    if (this.isSingleSoilHumiditySensorType(sensorType) && value === 'H10') {
      return this.translateService.instant('STATICS.SERIES.SOIL_MOISTURE');
    }
    return value;
  }

  private getAvailableSewerSystemTypeValues(sensorType: string | undefined): string[] {
    return this.getAvailableSewerSystemTypes(sensorType)
      .map((item: any) => item?.value)
      .filter(Boolean);
  }

  // Create sensor settings
  public createSensorSetting() {
    if (this.sensorFecha && this.hora) {
      const [hStr, mStr] = (this.hora || '00:00').split(':');
      const isDigital = this.editData?.sensorType === 'ED';
      const sensorSetting: any = {
        idSensor: this.editData.idSensor,
        instant:
          this.sensorFecha.getFullYear().toString() +
          ('0' + (this.sensorFecha.getMonth() + 1)).slice(-2) +
          ('0' + this.sensorFecha.getDate()).slice(-2) +
          'T' +
          ('0' + Number(hStr)).slice(-2) +
          ('0' + Number(mStr)).slice(-2) +
          '00'
      };

      if (isDigital) {
        sensorSetting.ed_invert = !!this.sensorEdInvert;
      } else {
        sensorSetting.hu_lts = this.sensorCampo;
        sensorSetting.hu_lti = this.sensorRecarga;
        sensorSetting.hu_h10 = this.sensorH1;
        sensorSetting.hu_h20 = this.sensorH2;
        sensorSetting.hu_h30 = this.sensorH3;
        sensorSetting.hu_h40 = this.sensorH4;
        sensorSetting.hu_h50 = this.sensorH5;
        sensorSetting.hu_h60 = this.sensorH6;
        sensorSetting.hu_h70 = this.sensorH7;
        sensorSetting.hu_h80 = this.sensorH8;
        sensorSetting.hu_sewerSystemType = this.normalizeSewerSystemType(
          this.sensorDrenaje
        );
        sensorSetting.calibration = parseFloat(
          this.sensorCalibracion
        ).toFixed(2);
        sensorSetting.fl_DrippersLine = this.sensorGoterosLinea;
        sensorSetting.fl_DrippersTree = this.sensorGoterosArbol;
        sensorSetting.co_permitivity = parseFloat(
          this.sensorPermitividad
        ).toFixed(2);
      }

      this.spinnerSvc.show();
      this.sensorService
        .createSensorSetting(sensorSetting)
        .pipe(
          finalize(() => {
            this.sensorService
              .getSensorSettings(this.editData.idSensor)
              .pipe(
                tap(sensorSettings => {
                  this.sensorSettings = sensorSettings;
                  this.saveSensorDates(sensorSettings);
                  // Reset form
                  if (isDigital) {
                    this.sensorEdInvert = false;
                  } else {
                    this.sensorCalibracion = 0;
                    this.sensorGoterosArbol = 0;
                    this.sensorGoterosLinea = 0;
                    this.sensorPermitividad = 0;
                    this.sensorCampo = 0;
                    this.sensorRecarga = 0;
                    this.sensorH1 = false;
                    this.sensorH2 = false;
                    this.sensorH3 = false;
                    this.sensorH4 = false;
                    this.sensorH5 = false;
                    this.sensorH6 = false;
                    this.sensorH7 = false;
                    this.sensorH8 = false;
                    this.sensorDrenaje = this.normalizeSewerSystemType('H10');
                  }
                  this.sensorFecha = new Date();
                }),
                finalize(() => this.spinnerSvc.hide())
              )
              .subscribe();
          })
        )
        .subscribe();
    }
  }

  public estacionSave() {
    const estacion: any = {
      latitude: this.estacionLat,
      longitude: this.estacionLng,
      stationType: this.estacionTipo,
      name: this.estacionNombre,
      city: this.estacionCiudad,
      idExternal: this.estacionIdExternal
    };
    if (this.formTitle === 'Editar') {
      estacion.idStation = this.editData.idStation;
    }
    this.saveOrEdit(estacion);
  }

  public usuarioSave() {
    if (this.formTitle === 'Crear') {
      const usuario = {
        telegramUsername: this.usuarioNombre
      };
      this.saveOrEdit(usuario);
      return;
    }

    if (this.formTitle === 'Editar') {
      this.saveUsuarioDialog();
      return;
    }
  }

  public saveUsuarioDialog(): void {
    if (this.formTitle !== 'Editar') {
      this.usuarioSave();
      return;
    }

    const userId = this.getCurrentEditingUserId();
    if (!userId) {
      return;
    }

    if (!this.validateUsuarioWeeklyReportForm()) {
      return;
    }

    const usuario = {
      idUser: this.editData.idUser,
      idCliente: this.editData.idCliente,
      telegramUsername: this.usuarioNombre
    };
    const email =
      this.editData?.email ||
      this.editData?.username ||
      this.editData?.userName ||
      this.editData?.login;

    let flow$: Observable<any>;
    if (!email) {
      this.snackBar.open(
        this.translateService.instant('SNACKBAR.USER_EMAIL_MISSING'),
        this.translateService.instant('COMMON.CLOSE'),
        {
          duration: 3500
        }
      );
      flow$ = this.$shttp.default.put(`/admin/user/${userId}`, usuario);
    } else {
      flow$ = this.updateUsuarioRoleIfNeeded(email).pipe(
        concatMap(() => this.$shttp.default.put(`/admin/user/${userId}`, usuario))
      );
    }

    this.usuarioWeeklyReportSaving = true;
    this.usuarioWeeklyReportErrors = [];
    flow$
      .pipe(
        concatMap(() =>
          this.weeklyReportSubscriptionService.upsertSubscriptionByUser(
            userId,
            this.buildUsuarioWeeklyReportPayload()
          )
        ),
        finalize(() => {
          this.usuarioWeeklyReportSaving = false;
          this.refresh();
        })
      )
      .subscribe({
        next: response => {
          this.applyUsuarioWeeklyReportResponse(response);
          this.dialogRef?.close();
        },
        error: error => {
          this.usuarioWeeklyReportErrors = [
            this.resolveUsuarioWeeklyReportError(error, 'SAVE_ERROR')
          ];
        }
      });
  }

  public clienteSave() {
    const cliente = {
      idCliente: undefined,
      name: this.clienteNombre,
      contactPersonPhone: this.clienteTelefono,
      address: this.clienteDireccion,
      city: this.clienteCiudad,
      state: this.clienteProvincia,
      country: this.clientePais,
      companyName: this.clienteEmpresa,
      taxId: this.clienteCIF,
      postalCode: this.clienteCP,
      contactPersonName: this.clienteContacto,
      contactPersonEmail: this.clienteEmail
    };
    if (this.formTitle === 'Editar') {
      cliente.idCliente = this.editData.idCliente;
    }
    this.saveOrEdit(cliente, 'cliente');
  }

  public fincaSave() {
    let finca: any;
    if (this.formTitle === 'Crear') {
      finca = {
        idCliente: this.fincaCliente,
        name: this.fincaNombre,
        city: this.fincaPoblacion,
        latitude: this.fincaLat,
        longitude: this.fincaLng
      };
    } else if (this.formTitle === 'Editar') {
      finca = {
        idCliente: this.fincaCliente,
        idFinca: this.editData.idFinca,
        name: this.fincaNombre,
        city: this.fincaPoblacion,
        latitude: this.fincaLat,
        longitude: this.fincaLng
      };
    }
    this.saveOrEdit(finca, 'finca');
  }

  public moduloSave() {
    const modulo = {
      idModule: undefined,
      idFinca: this.moduloFinca,
      name: this.moduloNombre,
      latitude: this.moduloLat,
      longitude: this.moduloLng,
      powerSupplyType: this.moduloPower,
      deviceMac: this.moduloMac,
      batteryCapacity: this.moduloBateria,
      aemetCode: this.moduloAemetCode
    };
    if (this.formTitle === 'Editar') {
      modulo.idModule = this.editData.idModule;
    }
    this.saveOrEdit(modulo, 'modulo');
  }

  public onCreateConfirm(event: any) {
    this.$shttp.default
      .post(this.table.getUrl(), event.newData)
      .pipe(finalize(() => this.refresh()))
      .subscribe();
  }

  public onDeleteConfirm(event: any) {
    let undelete = '';
    // Undelete entity
    if (event.data.isDeleted) {
      undelete = '/undelete';
    }
    this.$shttp.default
      .delete(
        `${this.table.getUrl()}/${
          event.data[this.table.getColumnId().getName()]
        }${undelete}`
      )
      .pipe(finalize(() => this.refresh()))
      .subscribe();
  }

  public onSaveConfirm(event: any) {
    this.$shttp.default
      .put(
        `${this.table.getUrl()}/${
          event.newData[this.table.getColumnId().getName()]
        }`,
        event.newData
      )
      .pipe(finalize(() => this.refresh()))
      .subscribe();
  }

  // Asociar cliente a usuario
  public asociarCliente() {
    if (this.usuarioAsociar === -1) return;
    this.clientService
      .associateClient(this.editData.idUser, this.usuarioAsociar)
      .pipe(
        tap(() => {
          this.loadUsuarioClientes(this.editData.idUser);
          this.usuarioAsociar = -1;
        }),
        finalize(() => this.refresh())
      )
      .subscribe();
  }

  // Desasociar cliente de usuario
  public desasociarCliente(idClient: number): void {
    this.clientService
      .removeClient(this.editData.idUser, idClient)
      .pipe(
        switchMap((res: any) => {
          const ids: number[] = Array.isArray(res?.clientIds) ? res.clientIds : [];
          if (!ids.length) {
            return of([]);
          }
          const requests = ids.map((id: number) =>
            this.$shttp.default
              .get(`/admin/cliente?idCliente=${id}`)
              .pipe(
                map((r: any) => (Array.isArray(r) ? r[0] : r)),
                catchError(() => of(null))
              )
          );
          return forkJoin(requests).pipe(
            map((results: any[]) => results.filter(Boolean))
          );
        }),
        catchError(() => of(null)),
        finalize(() => this.refresh())
      )
      .subscribe((clientes: any[] | null) => {
        if (clientes !== null) {
          this.usuarioClientesAsignados = clientes;
        }
      });
  }

  private loadUsuarioClientes(idUser: number): void {
    this.$shttp.default
      .get(`/admin/user/${idUser}`)
      .pipe(
        switchMap((user: any) => {
          const roleId =
            this.getRoleIdFromUser(user) ??
            this.getRoleIdFromUser(this.editData) ??
            this.usuarioRolId ??
            this.usuarioRolIdOriginal;
          if (roleId === 1) {
            return this.$shttp.default.get('/admin/cliente').pipe(
              map((clientes: any) =>
                (Array.isArray(clientes) ? clientes : []).filter(
                  (cliente: any) =>
                    !cliente?.isDeleted &&
                    String(cliente?.isDeleted) !== 'true'
                )
              ),
              catchError(() => of([]))
            );
          }

          const ids: number[] =
            Array.isArray(user?.clientIds) && user.clientIds.length
              ? user.clientIds
              : [user?.idCliente].filter(Boolean);
          if (!ids.length) {
            return of([]);
          }
          const requests = ids.map((id: number) =>
            this.$shttp.default
              .get(`/admin/cliente?idCliente=${id}`)
              .pipe(
                map((r: any) => (Array.isArray(r) ? r[0] : r)),
                catchError(() => of(null))
              )
          );
          return forkJoin(requests).pipe(
            map((results: any[]) => results.filter(Boolean))
          );
        }),
        switchMap((clientes: any[]) =>
          this.$shttp.default.get('/admin/finca').pipe(
            map((fincas: any) => ({
              clientes,
              fincas: Array.isArray(fincas) ? fincas : []
            })),
            catchError(() => of({ clientes, fincas: [] }))
          )
        ),
        catchError(() => of([]))
      )
      .subscribe((response: any) => {
        const clientes = Array.isArray(response?.clientes) ? response.clientes : [];
        const fincas = Array.isArray(response?.fincas) ? response.fincas : [];
        this.usuarioClientesAsignados = clientes;
        const clientIds = clientes
          .map(c => Number(c?.idCliente))
          .filter(id => Number.isFinite(id));
        this.usuarioFincasAutorizadas = getAuthorizedWeeklyReportFincas(
          fincas,
          clientIds
        );
        this.usuarioWeeklyReportForm.clientIds = this.usuarioWeeklyReportUsesAllAuthorizedClients
          ? clientIds
          : this.usuarioWeeklyReportForm.clientIds.filter(id =>
              clientIds.includes(Number(id))
            );
        const fincaIds = this.usuarioFincasAutorizadas.map(finca =>
          Number(finca?.idFinca)
        );
        this.usuarioWeeklyReportForm.fincaIds =
          this.usuarioWeeklyReportForm.fincaIds.filter(id =>
            fincaIds.includes(Number(id))
          );
        this.resolveUsuarioWeeklyReportLegacyFincas();
      });
  }

  public onUsuarioWeeklyReportScopeChange(): void {
    this.usuarioWeeklyReportUsesAllAuthorizedClients = false;
    if (this.usuarioWeeklyReportForm.scopeType !== 'selected_clients') {
      this.usuarioWeeklyReportForm.clientIds = [];
    }
    if (this.usuarioWeeklyReportForm.scopeType !== 'selected_fincas') {
      this.usuarioWeeklyReportForm.fincaIds = [];
    }
  }

  public getUsuarioWeeklyReportSendTimeOptions(): string[] {
    const normalizedCurrent = this.normalizeUsuarioWeeklyReportSendTime(
      this.usuarioWeeklyReportForm.sendTime
    );
    if (
      normalizedCurrent &&
      !this.usuarioWeeklyReportTimeOptions.includes(normalizedCurrent)
    ) {
      return [...this.usuarioWeeklyReportTimeOptions, normalizedCurrent].sort();
    }
    return this.usuarioWeeklyReportTimeOptions;
  }

  public onUsuarioWeeklyReportWeekStartChange(value: Date | null): void {
    this.usuarioWeeklyReportRunWeekStartDate = value;
    this.usuarioWeeklyReportRunWeekStart =
      this.formatUsuarioWeeklyReportDate(value) || '';
  }

  public saveUsuarioWeeklyReport(onSaved?: () => void): void {
    const userId = this.getCurrentEditingUserId();
    if (!userId) {
      return;
    }
    if (!this.validateUsuarioWeeklyReportForm()) {
      return;
    }

    this.usuarioWeeklyReportSaving = true;
    this.usuarioWeeklyReportErrors = [];
    this.weeklyReportSubscriptionService
      .upsertSubscriptionByUser(userId, this.buildUsuarioWeeklyReportPayload())
      .pipe(finalize(() => (this.usuarioWeeklyReportSaving = false)))
      .subscribe({
        next: response => {
          this.applyUsuarioWeeklyReportResponse(response);
          this.snackBar.open(
            this.translateService.instant('WEEKLY_REPORTS.SAVE_SUCCESS'),
            this.translateService.instant('COMMON.CLOSE'),
            { duration: 3500 }
          );
          onSaved?.();
        },
        error: error => {
          this.usuarioWeeklyReportErrors = [
            this.resolveUsuarioWeeklyReportError(error, 'SAVE_ERROR')
          ];
        }
      });
  }

  public previewUsuarioWeeklyReportPayload(): void {
    const subscriptionId = this.usuarioWeeklyReportSubscriptionId;
    if (!subscriptionId) {
      this.saveUsuarioWeeklyReport(() =>
        this.previewUsuarioWeeklyReportPayload()
      );
      return;
    }

    this.usuarioWeeklyReportPreviewLoading = true;
    this.usuarioWeeklyReportErrors = [];
    this.weeklyReportSubscriptionService
      .previewPayload(subscriptionId, this.usuarioWeeklyReportRunWeekStart || null)
      .pipe(finalize(() => (this.usuarioWeeklyReportPreviewLoading = false)))
      .subscribe({
        next: response => {
          this.usuarioWeeklyReportPreviewPayload = JSON.stringify(
            response,
            null,
            2
          );
        },
        error: error => {
          this.usuarioWeeklyReportErrors = [
            this.resolveUsuarioWeeklyReportError(error, 'PREVIEW_ERROR')
          ];
        }
      });
  }

  public runUsuarioWeeklyReportManually(): void {
    const subscriptionId = this.usuarioWeeklyReportSubscriptionId;
    if (!subscriptionId) {
      this.saveUsuarioWeeklyReport(() => this.runUsuarioWeeklyReportManually());
      return;
    }

    this.usuarioWeeklyReportRunLoading = true;
    this.usuarioWeeklyReportErrors = [];
    this.weeklyReportSubscriptionService
      .runSubscription(subscriptionId, {
        weekStart: this.usuarioWeeklyReportRunWeekStart || null,
        force: true
      })
      .pipe(finalize(() => (this.usuarioWeeklyReportRunLoading = false)))
      .subscribe({
        next: response => {
          this.usuarioWeeklyReportLastRunId =
            this.extractUsuarioWeeklyReportRunId(response);
          this.snackBar.open(
            this.translateService.instant('WEEKLY_REPORTS.RUN_SUCCESS'),
            this.translateService.instant('COMMON.CLOSE'),
            { duration: 3500 }
          );
        },
        error: error => {
          this.usuarioWeeklyReportErrors = [
            this.resolveUsuarioWeeklyReportError(error, 'RUN_ERROR')
          ];
        }
      });
  }

  public openUsuarioWeeklyReportHtmlPreview(): void {
    if (!this.usuarioWeeklyReportLastRunId) {
      return;
    }

    this.usuarioWeeklyReportHtmlLoading = true;
    this.usuarioWeeklyReportErrors = [];
    this.weeklyReportSubscriptionService
      .previewRunHtml(this.usuarioWeeklyReportLastRunId)
      .pipe(finalize(() => (this.usuarioWeeklyReportHtmlLoading = false)))
      .subscribe({
        next: html => {
          const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank', 'noopener');
          setTimeout(() => URL.revokeObjectURL(url), 60000);
        },
        error: error => {
          this.usuarioWeeklyReportErrors = [
            this.resolveUsuarioWeeklyReportError(error, 'HTML_ERROR')
          ];
        }
      });
  }

  public generateUsuarioWeeklyReportPdf(): void {
    if (!this.usuarioWeeklyReportLastRunId) {
      return;
    }

    this.usuarioWeeklyReportPdfLoading = true;
    this.usuarioWeeklyReportErrors = [];
    this.weeklyReportSubscriptionService
      .generateRunPdf(this.usuarioWeeklyReportLastRunId)
      .pipe(finalize(() => (this.usuarioWeeklyReportPdfLoading = false)))
      .subscribe({
        next: () => {
          this.snackBar.open(
            this.translateService.instant('WEEKLY_REPORTS.PDF_SUCCESS'),
            this.translateService.instant('COMMON.CLOSE'),
            { duration: 3500 }
          );
        },
        error: error => {
          this.usuarioWeeklyReportErrors = [
            this.resolveUsuarioWeeklyReportError(error, 'PDF_ERROR')
          ];
        }
      });
  }

  public downloadUsuarioWeeklyReportPdf(): void {
    if (!this.usuarioWeeklyReportLastRunId) {
      return;
    }

    this.usuarioWeeklyReportPdfLoading = true;
    this.usuarioWeeklyReportErrors = [];
    this.weeklyReportSubscriptionService
      .downloadRunPdf(this.usuarioWeeklyReportLastRunId)
      .pipe(finalize(() => (this.usuarioWeeklyReportPdfLoading = false)))
      .subscribe({
        next: blob => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `weekly-report-${this.usuarioWeeklyReportLastRunId}.pdf`;
          link.click();
          setTimeout(() => URL.revokeObjectURL(url), 60000);
        },
        error: error => {
          this.usuarioWeeklyReportErrors = [
            this.resolveUsuarioWeeklyReportError(error, 'DOWNLOAD_ERROR')
          ];
        }
      });
  }

  public resendUsuarioWeeklyReportEmail(): void {
    if (!this.usuarioWeeklyReportLastRunId) {
      return;
    }

    this.usuarioWeeklyReportEmailLoading = true;
    this.usuarioWeeklyReportErrors = [];
    this.weeklyReportSubscriptionService
      .sendRunEmail(this.usuarioWeeklyReportLastRunId)
      .pipe(finalize(() => (this.usuarioWeeklyReportEmailLoading = false)))
      .subscribe({
        next: () => {
          this.snackBar.open(
            this.translateService.instant('WEEKLY_REPORTS.EMAIL_SUCCESS'),
            this.translateService.instant('COMMON.CLOSE'),
            { duration: 3500 }
          );
        },
        error: error => {
          this.usuarioWeeklyReportErrors = [
            this.resolveUsuarioWeeklyReportError(error, 'EMAIL_ERROR')
          ];
        }
      });
  }

  public getUsuarioWeeklyReportFincaLabel(finca: any): string {
    const clientId = Number(
      finca?.idCliente ?? finca?.cliente?.idCliente ?? finca?.client?.idCliente
    );
    const client = this.usuarioClientesAsignados.find(
      item => Number(item?.idCliente) === clientId
    );
    return getWeeklyReportFincaLabel({
      ...finca,
      clientName: finca?.clientName ?? client?.name
    });
  }

  public getUsuarioWeeklyReportFincas(): any[] {
    return [...this.usuarioFincasAutorizadas].sort((a: any, b: any) =>
      this.getUsuarioWeeklyReportFincaLabel(a).localeCompare(
        this.getUsuarioWeeklyReportFincaLabel(b),
        undefined,
        { sensitivity: 'base' }
      )
    );
  }

  private resolveUsuarioWeeklyReportLegacyFincas(): void {
    if (
      !this.usuarioWeeklyReportLegacyModuleIds.length ||
      this.usuarioWeeklyReportForm.scopeType !== 'selected_fincas'
    ) {
      return;
    }

    const fincaIds = this.usuarioWeeklyReportLegacyModuleIds
      .map(moduleId =>
        (this.modulos || []).find(
          module => Number(module?.idModule) === moduleId
        )
      )
      .map(module =>
        Number(module?.idFinca ?? module?.finca?.idFinca ?? module?.fincaId)
      )
      .filter(id => Number.isFinite(id));

    if (fincaIds.length) {
      const authorizedFincaIds = new Set(
        this.usuarioFincasAutorizadas.map(finca => Number(finca?.idFinca))
      );
      this.usuarioWeeklyReportForm.fincaIds = normalizeWeeklyReportIds(fincaIds).filter(
        id => !authorizedFincaIds.size || authorizedFincaIds.has(id)
      );
      this.usuarioWeeklyReportLegacyModuleIds = [];
    }
  }

  private loadUsuarioWeeklyReport(idUser: number): void {
    this.resetUsuarioWeeklyReportState();
    this.usuarioWeeklyReportLoading = true;
    this.weeklyReportSubscriptionService
      .getSubscriptionByUser(idUser)
      .pipe(finalize(() => (this.usuarioWeeklyReportLoading = false)))
      .subscribe({
        next: response => this.applyUsuarioWeeklyReportResponse(response),
        error: error => {
          this.usuarioWeeklyReportErrors = [
            this.resolveUsuarioWeeklyReportError(error, 'LOAD_ERROR')
          ];
        }
      });
  }

  private applyUsuarioWeeklyReportResponse(response: any): void {
    const subscription = response?.subscription || response || null;
    const scope = response?.scope || {};
    const defaults = this.getDefaultWeeklyReportForm();
    const storedScopeType = String(subscription?.scopeType || defaults.scopeType || '');
    const legacyModuleIds = normalizeWeeklyReportIds(scope?.moduleIds);
    const fincaIds = normalizeWeeklyReportIds(
      scope?.fincaIds ??
        scope?.resolvedFincaIds ??
        scope?.resolvedScope?.fincaIds ??
        response?.fincaIds
    );

    this.usuarioWeeklyReportUsesAllAuthorizedClients =
      storedScopeType === 'all_assigned_clients';
    this.usuarioWeeklyReportLegacyModuleIds =
      storedScopeType === 'selected_modules' && !fincaIds.length
        ? legacyModuleIds
        : [];

    this.usuarioWeeklyReportSubscriptionId = Number(
      subscription?.idWeeklyReportSubscription || 0
    ) || null;
    const authorizedClientIds = this.usuarioClientesAsignados
      .map(client => Number(client?.idCliente))
      .filter(id => Number.isFinite(id));
    const authorizedFincaIds = new Set(
      this.usuarioFincasAutorizadas.map(finca => Number(finca?.idFinca))
    );
    this.usuarioWeeklyReportForm = {
      enabled:
        subscription?.isEnabled ?? subscription?.enabled ?? defaults.enabled,
      plan: String(subscription?.plan || defaults.plan || ''),
      scopeType: normalizeWeeklyReportScopeType(storedScopeType),
      sendDay: String(
        subscription?.sendDay || defaults.sendDay || 'MONDAY'
      ).toUpperCase(),
      sendTime: String(
        subscription?.sendTime || defaults.sendTime || '08:00'
      ).slice(0, 5),
      timezone: String(
        subscription?.timezone || defaults.timezone || 'Europe/Madrid'
      ),
      language: String(
        subscription?.language || defaults.language || this.getDefaultLanguage()
      ),
      clientIds: this.usuarioWeeklyReportUsesAllAuthorizedClients
        ? authorizedClientIds
        : normalizeWeeklyReportIds(scope?.clientIds).filter(
            id => !authorizedClientIds.length || authorizedClientIds.includes(id)
          ),
      fincaIds: fincaIds.filter(
        id => !authorizedFincaIds.size || authorizedFincaIds.has(id)
      )
    };
    this.resolveUsuarioWeeklyReportLegacyFincas();
  }

  private buildUsuarioWeeklyReportPayload(): any {
    const normalizedSendTime = this.normalizeUsuarioWeeklyReportSendTime(
      this.usuarioWeeklyReportForm.sendTime
    );
    const scopePayload = buildWeeklyReportScopePayload(
      this.usuarioWeeklyReportForm.scopeType,
      this.usuarioWeeklyReportForm.clientIds,
      this.usuarioWeeklyReportForm.fincaIds
    );
    return {
      enabled: this.usuarioWeeklyReportForm.enabled,
      plan: this.usuarioWeeklyReportForm.plan,
      sendDay: this.usuarioWeeklyReportForm.sendDay,
      sendTime: normalizedSendTime,
      timezone: this.usuarioWeeklyReportForm.timezone,
      language: this.usuarioWeeklyReportForm.language,
      ...scopePayload
    };
  }

  private validateUsuarioWeeklyReportForm(): boolean {
    const errors: string[] = [];
    this.usuarioWeeklyReportForm.sendTime =
      this.normalizeUsuarioWeeklyReportSendTime(
        this.usuarioWeeklyReportForm.sendTime
      );
    if (!this.usuarioWeeklyReportForm.plan) {
      errors.push(
        this.translateService.instant('WEEKLY_REPORTS.VALIDATION_PLAN')
      );
    }
    if (!this.usuarioWeeklyReportForm.scopeType) {
      errors.push(
        this.translateService.instant('WEEKLY_REPORTS.VALIDATION_SCOPE')
      );
    }
    if (
      this.usuarioWeeklyReportForm.scopeType === 'selected_clients' &&
      !hasWeeklyReportScopeSelection(
        this.usuarioWeeklyReportForm.scopeType,
        this.usuarioWeeklyReportForm.clientIds,
        this.usuarioWeeklyReportForm.fincaIds
      )
    ) {
      errors.push(
        this.translateService.instant('WEEKLY_REPORTS.VALIDATION_CLIENTS')
      );
    }
    if (
      this.usuarioWeeklyReportForm.scopeType === 'selected_fincas' &&
      !hasWeeklyReportScopeSelection(
        this.usuarioWeeklyReportForm.scopeType,
        this.usuarioWeeklyReportForm.clientIds,
        this.usuarioWeeklyReportForm.fincaIds
      )
    ) {
      errors.push(
        this.translateService.instant('WEEKLY_REPORTS.VALIDATION_FINCAS')
      );
    }
    if (
      !/^([01]\d|2[0-3]):[0-5]\d$/.test(this.usuarioWeeklyReportForm.sendTime)
    ) {
      errors.push(
        this.translateService.instant('WEEKLY_REPORTS.VALIDATION_TIME')
      );
    }
    if (!this.usuarioWeeklyReportForm.timezone) {
      errors.push(
        this.translateService.instant('WEEKLY_REPORTS.VALIDATION_TIMEZONE')
      );
    }
    if (!this.usuarioWeeklyReportForm.language) {
      errors.push(
        this.translateService.instant('WEEKLY_REPORTS.VALIDATION_LANGUAGE')
      );
    }
    this.usuarioWeeklyReportErrors = errors;
    return errors.length === 0;
  }

  private normalizeUsuarioWeeklyReportSendTime(value: any): string {
    const raw = String(value ?? '').trim();
    if (!raw) {
      return '';
    }
    const match = raw.match(/^(\d{2}:\d{2})(?::\d{2})?$/);
    return match ? match[1] : raw;
  }

  private resetUsuarioWeeklyReportState(): void {
    this.usuarioWeeklyReportLoading = false;
    this.usuarioWeeklyReportSaving = false;
    this.usuarioWeeklyReportPreviewLoading = false;
    this.usuarioWeeklyReportRunLoading = false;
    this.usuarioWeeklyReportHtmlLoading = false;
    this.usuarioWeeklyReportPdfLoading = false;
    this.usuarioWeeklyReportEmailLoading = false;
    this.usuarioWeeklyReportErrors = [];
    this.usuarioWeeklyReportPreviewPayload = '';
    this.usuarioWeeklyReportRunWeekStart = this.getCurrentWeekStart();
    this.usuarioWeeklyReportRunWeekStartDate = this.parseUsuarioWeeklyReportDate(
      this.usuarioWeeklyReportRunWeekStart
    );
    this.usuarioWeeklyReportLastRunId = null;
    this.usuarioWeeklyReportSubscriptionId = null;
    this.usuarioWeeklyReportUsesAllAuthorizedClients = false;
    this.usuarioWeeklyReportLegacyModuleIds = [];
    this.usuarioWeeklyReportForm = this.getDefaultWeeklyReportForm();
  }

  private getCurrentEditingUserId(): number | null {
    const id = Number(this.editData?.idUser || 0);
    return Number.isFinite(id) && id > 0 ? id : null;
  }

  private getDefaultWeeklyReportForm() {
    return {
      enabled: false,
      plan: 'basic',
      scopeType: 'selected_clients',
      sendDay: 'MONDAY',
      sendTime: '08:00',
      timezone: this.getBrowserTimezone(),
      language: this.getDefaultLanguage(),
      clientIds: [],
      fincaIds: []
    };
  }

  private getDefaultLanguage(): string {
    const current = (this.translateService.currentLang || 'es').toLowerCase();
    if (current.startsWith('fr')) return 'fr-FR';
    if (current.startsWith('en')) return 'en-US';
    return 'es-ES';
  }

  private getBrowserTimezone(): string {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Madrid';
    } catch (_error) {
      return 'Europe/Madrid';
    }
  }

  private getCurrentWeekStart(): string {
    const today = new Date();
    const currentDay = today.getDay();
    const delta = currentDay === 0 ? -6 : 1 - currentDay;
    const start = new Date(today);
    start.setDate(today.getDate() + delta);
    const year = start.getFullYear();
    const month = String(start.getMonth() + 1).padStart(2, '0');
    const day = String(start.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private buildUsuarioWeeklyReportTimeOptions(): string[] {
    const options: string[] = [];
    for (let hour = 0; hour < 24; hour += 1) {
      for (let minute = 0; minute < 60; minute += 15) {
        options.push(
          `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
        );
      }
    }
    return options;
  }

  private parseUsuarioWeeklyReportDate(
    value: string | null | undefined
  ): Date | null {
    const raw = String(value || '').trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      return null;
    }
    const [year, month, day] = raw.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  private formatUsuarioWeeklyReportDate(
    value: Date | null | undefined
  ): string {
    if (!(value instanceof Date) || Number.isNaN(value.getTime())) {
      return '';
    }
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private buildTimezoneOptions(): string[] {
    const browserTimezone = this.getBrowserTimezone();
    const intlAny = Intl as any;
    const values =
      typeof intlAny.supportedValuesOf === 'function'
        ? intlAny.supportedValuesOf('timeZone')
        : ['Europe/Madrid', 'UTC', browserTimezone];
    return Array.from(
      new Set<string>(['Europe/Madrid', 'UTC', browserTimezone, ...values])
    ).sort((a, b) => a.localeCompare(b));
  }

  private extractUsuarioWeeklyReportRunId(response: any): number | null {
    const rawId =
      response?.run?.idWeeklyReportRun ??
      response?.run?.id ??
      response?.idWeeklyReportRun ??
      response?.id;
    const runId = Number(rawId);
    return Number.isFinite(runId) && runId > 0 ? runId : null;
  }

  private resolveUsuarioWeeklyReportError(
    error: any,
    fallbackKey: string
  ): string {
    const payload = error?.error;
    if (Array.isArray(payload) && payload[0]?.message) {
      return String(payload[0].message);
    }
    if (payload?.message) {
      return String(payload.message);
    }
    if (typeof payload === 'string' && payload.trim()) {
      return payload;
    }
    return this.translateService.instant(`WEEKLY_REPORTS.${fallbackKey}`);
  }

  // Se podría importar/exportar si se repite mucho
  private convertMinsToHrsMins() {
    let h: any = Math.floor(Math.abs(this.offset) / 60);
    let m: any = this.offset % 60;
    h = h < 10 ? '0' + h : h;
    m = m < 10 ? '0' + m : m;
    if (this.offset >= 0) {
      return `+${h}:${m}`;
    } else {
      return `-${h}:${m}`;
    }
  }

  private availableTableActions(): void {
    const tableActions = {
      canCreate: this.table.getViews().getCanCreate().length > 0,
      canDelete: this.table.getViews().getCanDelete(),
      canUpdate: this.table.getViews().getCanUpdate().length > 0
    };

    if (!!Object.values(tableActions).find(_ => !!_)) {
      this.tableActions = tableActions;
    } else {
      this.tableActions = null;
    }
  }

  private loadClientesForUser(): void {
    this.$shttp.default
      .get('/user/me')
      .pipe(
        switchMap((user: any) => {
          const roleId = this.getRoleIdFromUser(user);
          this.userRoleId = roleId;
          this.updateCreateVisibility();
          if (this.tableRows && this.tableRows.length) {
            this.dataTable();
          }
          return this.$shttp.default.get('/admin/cliente').pipe(
            switchMap((data: any) => {
              const list = Array.isArray(data) ? data : [];
              if (roleId === 1) {
                return of({ list, ids: [] });
              }
              const ids =
                Array.isArray(user?.idClientes) && user.idClientes.length
                  ? user.idClientes
                  : [user?.idCliente].filter(Boolean);
              const missing = ids.filter(
                id => !list.some(c => c?.idCliente === id)
              );
              if (!missing.length) {
                return of({ list, ids });
              }
              const requests: Array<Observable<any[]>> = missing.map(id =>
                this.$shttp.default
                  .get(`/admin/cliente?idCliente=${id}`)
                  .pipe(catchError(() => of([])))
              );
              return forkJoin(requests).pipe(
                map((results: any[][]) => {
                  const extra = ([] as any[]).concat(...results).filter(Boolean);
                  return { list: [...list, ...extra], ids };
                }),
                catchError(() => of({ list, ids }))
              );
            }),
            map(({ list, ids }) => {
              if (!ids.length) {
                return list;
              }
              return list.filter(c => ids.includes(c.idCliente));
            })
          );
        }),
        tap(clientes => {
          this.clientes = clientes;
          this.clientService.setData(clientes);
        }),
        catchError(() => of([]))
      )
      .subscribe();
  }

  private localizeSensorTypes(types: any[] | null | undefined): any[] {
    if (!types) {
      return [];
    }
    return types.map(t => {
      const key = this.getSensorTypeNameKey(t?.value);
      const name = key ? this.translateService.instant(key) : t?.name;
      return { ...t, name: name || t?.name || t?.value };
    });
  }

  private getSensorTypeNameKey(value: string | undefined): string | null {
    switch (value) {
      case 'TE':
        return 'STATICS.SENSOR_TYPES.AMBIENT_TEMP';
      case 'FL':
        return 'STATICS.SENSOR_TYPES.FLOW';
      case 'HU':
        return 'STATICS.SENSOR_TYPES.HUMIDITY';
      case 'SH':
        return 'STATICS.SENSOR_TYPES.SOIL_HUMIDITY';
      case 'SC':
        return 'STATICS.SENSOR_TYPES.SOIL_CONDUCTIVITY';
      case 'HH':
        return 'STATICS.SENSOR_TYPES.LEAF_HUMIDITY';
      case 'E8':
        return 'STATICS.SENSOR_TYPES.ENVIROPRO_8';
      case 'DE':
        return 'STATICS.SENSOR_TYPES.DENDROMETER';
      case 'ED':
        return 'SensorType_ED';
      case 'DIGITAL':
        return 'SensorType_DIGITAL';
      case 'PL':
        return 'STATICS.SENSOR_TYPES.PLUVIOMETER';
      case 'BA':
        return 'STATICS.SENSOR_TYPES.BATTERY';
      case 'AN':
        return 'STATICS.SENSOR_TYPES.ANEMOMETER';
      case 'CO':
      case 'WC':
        return 'STATICS.SENSOR_TYPES.CONDUCTIVITY';
      default:
        return null;
    }
  }
}
